import { mediaRef } from '@/services/mediaAssets';
import eaglesStorySections from './eaglesStory';
import u2StorySections from './u2Story';
import valleyOfFireGallery from './valleyOfFireGallery';
import whiskyStorySections from './whiskyStory';
import zionHikeGallery from './zionHikeGallery';
import zionStoryPages from './zionStory';
import { achievementRefs, tagRefs } from '../../../reckonWayTags';
import {
  getRecurringActivities,
  getRecurringAttendees,
  getRecurringEventStats,
  getRecurringRestaurantVisits,
} from '../../recurringEvent';
import { defineReckonEvent } from '../../schema';

const awsReinventHero = mediaRef('adventures/aws-reinvent-heroes-no-text.png');
const bazaarBitesImage = mediaRef('adventures/aws-reinvent-2023-bazaar-bites.jpg');
const bazaarCottonCandyImage = mediaRef('adventures/aws-reinvent-2023-bazaar-cotton-candy.jpg');
const bazaarSteakImage = mediaRef('adventures/aws-reinvent-2023-bazaar-steak.jpg');
const brezzaDinnerImage = mediaRef('adventures/aws-reinvent-2024-brezza-3025.jpg');
const donsPrimeDinnerImage = mediaRef('adventures/aws-reinvent-2024-dons-prime-3048.jpg');
const stkDinnerImage = mediaRef('adventures/aws-reinvent-2023-stk-6013.jpg');
const stkCrewImage = mediaRef('adventures/aws-reinvent-2023-stk-9530.jpg');
const stkToastImage = mediaRef('adventures/aws-reinvent-2023-stk-9532.jpg');
const stkDinner2024Image = mediaRef('adventures/aws-reinvent-2024-stk-3005.jpg');
const utvCrewGroupImage = mediaRef('adventures/aws-reinvent-2023-utv-crew-group.jpg');
const utvDriverImage = mediaRef('adventures/aws-reinvent-2023-utv-driver.jpg');
const utvTrailBreakImage = mediaRef('adventures/aws-reinvent-2023-utv-trail-break.jpg');
const utvGearUpImage = mediaRef('adventures/aws-reinvent-2023-utv-9554.jpg');
const utvTrailBriefingImage = mediaRef('adventures/aws-reinvent-2023-utv-9555.jpg');
const utvDriverViewImage = mediaRef('adventures/aws-reinvent-2023-utv-9556.jpg');
const utvBehindTheWheelImage = mediaRef('adventures/aws-reinvent-2023-utv-9557.jpg');
const catchFlowerWallImage = mediaRef('adventures/aws-reinvent-2023-catch-9539.jpg');
const catchDinner2023Image = mediaRef('adventures/aws-reinvent-2023-catch-9545.jpg');
const u2SphereCrewWithExosphereImage = mediaRef('adventures/aws-reinvent-2023-u2-sphere-crew-with-exosphere.jpg');
const u2SphereSection405Image = mediaRef('adventures/aws-reinvent-2023-u2-sphere-section-405.jpg');
const u2SphereCrewImage = mediaRef('adventures/aws-reinvent-2023-u2-sphere-9591.jpg');
const u2SphereConcertImage = mediaRef('adventures/aws-reinvent-2023-u2-sphere-9610.jpg');
const u2SphereArrivalVideo = mediaRef('adventures/aws-reinvent-2023-u2-sphere-arrival.mp4', {
  firebaseAssetId: 'u2-sphere-video-arrival',
});
const u2SphereTheFlyVideo = mediaRef('adventures/aws-reinvent-2023-u2-sphere-the-fly.mp4', {
  firebaseAssetId: 'u2-sphere-video-the-fly',
});
const u2SphereAtomicCityVideo = mediaRef('adventures/aws-reinvent-2023-u2-sphere-atomic-city.mp4', {
  firebaseAssetId: 'u2-sphere-video-atomic-city',
});
const u2SphereWhereStreetsVideo = mediaRef('adventures/aws-reinvent-2023-u2-sphere-where-streets.mp4', {
  firebaseAssetId: 'u2-sphere-video-where-streets',
});
const catchTeamDinnerImage = mediaRef('adventures/aws-reinvent-catch-team-dinner.png');
const eaglesAtSphereGroupImage = mediaRef('adventures/aws-reinvent-eagles-at-sphere-group.png');
const eaglesArrivalLobbyImage = mediaRef('adventures/aws-reinvent/eagles/arrival-lobby.webp');
const eaglesHotelCaliforniaImage = mediaRef('adventures/aws-reinvent/eagles/hotel-california-eagle.webp');
const eaglesLyinEyesImage = mediaRef('adventures/aws-reinvent/eagles/lyin-eyes-lyrics.webp');
const eaglesInTheCityTenementImage = mediaRef('adventures/aws-reinvent/eagles/in-the-city-tenement.webp');
const eaglesInTheCityCylinderImage = mediaRef('adventures/aws-reinvent/eagles/in-the-city-cylinder.webp');
const eaglesNewKidArchiveImage = mediaRef('adventures/aws-reinvent/eagles/new-kid-in-town-archive.webp');
const eaglesFinaleImage = mediaRef('adventures/aws-reinvent/eagles/finale.webp');
const estiatorioMilosSeafoodImage = mediaRef('adventures/aws-reinvent-2024-estiatorio-milos-seafood.jpg');
const goldenSteerGroupImage = mediaRef('adventures/aws-reinvent-golden-steer-group.png');
const whiskeyTastingCrewImage = mediaRef('adventures/aws-reinvent-2024-whiskey-tasting-crew.jpg');
const whiskeysOfTheWorldImage = mediaRef('adventures/aws-reinvent-whiskeys-of-the-world.jpg');
const whiskySuitePartyImage = mediaRef('adventures/aws-reinvent/whisky/aws-reinvent-2024-whisky-suite-party.jpg');
const whiskyBalconyGlassImage = mediaRef('adventures/aws-reinvent/whisky/aws-reinvent-2024-whisky-balcony-glass.jpg');
const whiskyBottleLineupVideo = mediaRef('adventures/aws-reinvent-2024-whisky-bottles.mp4', {
  firebaseAssetId: 'whisky-tasting-video-bottles',
});
const whiskyCstemTastingVideo = mediaRef('adventures/aws-reinvent-2024-whisky-cstem-tasting.mp4', {
  firebaseAssetId: 'whisky-tasting-video-cstem',
});
const vegas2022Stk5298Image = mediaRef('adventures/aws-reinvent-2022-5298.jpg');
const vegas2022Stk5302Image = mediaRef('adventures/aws-reinvent-2022-5302.jpg');
const vegas2022Atv5314Image = mediaRef('adventures/aws-reinvent-2022-5314.jpg');
const vegas2022Atv5315Image = mediaRef('adventures/aws-reinvent-2022-5315.jpg');
const vegas2022Atv5318Image = mediaRef('adventures/aws-reinvent-2022-5318.jpg');
const vegas2022Amalfi5383Image = mediaRef('adventures/aws-reinvent-2022-5383.jpg');
const vegas2022Bazaar5396Image = mediaRef('adventures/aws-reinvent-2022-5396.jpg');
const vegas2022Bazaar5398Image = mediaRef('adventures/aws-reinvent-2022-5398.jpg');
const alHeadshot = mediaRef('lames/Al M.jpeg');
const benHeadshot = mediaRef('lames/Ben B.jpeg');
const brandonAHeadshot = mediaRef('lames/Brandon A New.jpeg');
const brandonLHeadshot = mediaRef('lames/Brandon L New.jpeg');
const jasmineHeadshot = mediaRef('lames/Jasmine B.jpeg');
const kevinHeadshot = mediaRef('lames/Kevin L.jpeg');
const marcusHeadshot = mediaRef('lames/Marcus G New.jpeg');
const mattHeadshot = mediaRef('lames/Matt G.jpeg');

const u2SphereCrewWithExospherePhoto = {
  id: 'u2-sphere-crew-with-exosphere',
  src: u2SphereCrewWithExosphereImage,
  alt: 'The Reckon crew together with the Exosphere behind them during AWS re:Invent 2023',
  caption: 'The crew with Sphere before returning for U2 that evening.',
  capturedAt: '2023-11-28T12:58:59',
};

const u2SphereSection405Photo = {
  id: 'u2-sphere-section-405-view',
  src: u2SphereSection405Image,
  alt: 'The view from Section 405 across the steep seating bowl and stage inside Sphere',
  caption: 'The view from Section 405, Row 17, before U2 took the stage.',
  capturedAt: '2023-12-01T19:40:00',
};

const u2SphereArrivalClip = {
  id: 'u2-sphere-video-arrival',
  type: 'video',
  src: u2SphereArrivalVideo,
  mimeType: 'video/mp4',
  alt: 'The U2 UV display inside Sphere as the Reckon crew arrived for the concert',
  caption: 'Finally inside Sphere beneath the U2:UV display.',
  captionsSrc: '/captions/aws-reinvent-2023-u2-sphere-arrival.vtt',
  capturedAt: '2023-12-01T19:33:40',
};

const u2SphereTheFlyClip = {
  id: 'u2-sphere-video-the-fly',
  type: 'video',
  src: u2SphereTheFlyVideo,
  mimeType: 'video/mp4',
  alt: 'Colorful letters and symbols surrounding the audience during The Fly at Sphere',
  caption: 'The Fly surrounding Sphere with cascading letters, symbols, and color.',
  captionsSrc: '/captions/aws-reinvent-2023-u2-sphere-the-fly.vtt',
  capturedAt: '2023-12-01T20:47:07',
};

const u2SphereAtomicCityClip = {
  id: 'u2-sphere-video-atomic-city',
  type: 'video',
  src: u2SphereAtomicCityVideo,
  mimeType: 'video/mp4',
  alt: 'Las Vegas imagery transforming around U2 during Atomic City at Sphere',
  caption: 'Las Vegas transforming around us during Atomic City.',
  captionsSrc: '/captions/aws-reinvent-2023-u2-sphere-atomic-city.vtt',
  capturedAt: '2023-12-01T22:21:31',
};

const u2SphereWhereStreetsClip = {
  id: 'u2-sphere-video-where-streets',
  type: 'video',
  src: u2SphereWhereStreetsVideo,
  mimeType: 'video/mp4',
  alt: 'A sweeping landscape surrounding U2 during Where the Streets Have No Name at Sphere',
  caption: 'Sphere opening into an endless landscape during Where the Streets Have No Name.',
  captionsSrc: '/captions/aws-reinvent-2023-u2-sphere-where-streets.vtt',
  capturedAt: '2023-12-01T22:30:47',
};

const whiskySuitePartyPhoto = {
  id: 'whisky-suite-party',
  src: whiskySuitePartyImage,
  alt: 'Guests talking inside the Cosmopolitan suite beside the open balcony during the whisky tasting',
  caption: 'Guests moving between the suite and balcony with the Las Vegas Strip just outside.',
};

const whiskyBalconyGlassPhoto = {
  id: 'whisky-balcony-glass',
  src: whiskyBalconyGlassImage,
  alt: 'A whisky glass held above the Las Vegas Strip from the Cosmopolitan wraparound balcony',
  caption: 'A whisky pour above the Strip from the Cosmopolitan wraparound balcony.',
  capturedAt: '2024-12-03T19:41:49',
};

const whiskyBottleLineupClip = {
  id: 'whisky-tasting-video-bottles',
  type: 'video',
  src: whiskyBottleLineupVideo,
  mimeType: 'video/mp4',
  alt: 'A black-and-white pan across the worldwide whisky bottle lineup',
  title: 'The Worldwide Lineup',
  caption: 'A closer look at the whiskies JD brought to the suite.',
  capturedAt: '2024-12-03T16:04:23',
};

const whiskyCstemTastingClip = {
  id: 'whisky-tasting-video-cstem',
  type: 'video',
  src: whiskyCstemTastingVideo,
  mimeType: 'video/mp4',
  alt: 'Guests holding tasting glasses and practicing the whisky tasting method inside the suite',
  title: 'Putting C-STEM Into Practice',
  caption: 'Guests applying the tasting method together inside the suite.',
  capturedAt: '2024-12-03T19:23:01',
};

const eaglesStoryGallery = [
  {
    id: 'eagles-at-sphere-group',
    src: eaglesAtSphereGroupImage,
    alt: 'The Reckon crew beneath the Eagles Live at Sphere display in Las Vegas',
    caption: 'Back at Sphere with a larger Reckon crew during AWS re:Invent 2024.',
  },
  {
    id: 'eagles-sphere-arrival-lobby',
    src: eaglesArrivalLobbyImage,
    alt: 'Eagles signage inside the Sphere lobby as the group arrived after the show began',
    caption: 'Inside Sphere at 8:38 p.m., already racing the opening song.',
  },
  {
    id: 'eagles-hotel-california-eagle',
    src: eaglesHotelCaliforniaImage,
    alt: 'A giant eagle spreading its wings across Sphere during Hotel California',
    caption: 'Walking into the room beneath the giant eagle during “Hotel California.”',
  },
  {
    id: 'eagles-lyin-eyes-lyrics',
    src: eaglesLyinEyesImage,
    alt: 'Handwritten Lyin Eyes lyrics rising into a starry sky inside Sphere',
    caption: '“Lyin’ Eyes” written across the night sky.',
  },
  {
    id: 'eagles-in-the-city-tenement',
    src: eaglesInTheCityTenementImage,
    alt: 'Black-and-white tenement buildings surrounding the audience during In the City',
    caption: '“In the City” began inside a canyon of tenement buildings.',
  },
  {
    id: 'eagles-in-the-city-cylinder',
    src: eaglesInTheCityCylinderImage,
    alt: 'The cityscape twisting into a tall cylinder across the interior of Sphere',
    caption: 'Then the entire city bent and curled above us.',
  },
  {
    id: 'eagles-new-kid-in-town-archive',
    src: eaglesNewKidArchiveImage,
    alt: 'Filmstrips, guitars, and archival Eagles imagery surrounding the band during New Kid in Town',
    caption: '“New Kid in Town” turned the dome into a three-dimensional archive.',
  },
  {
    id: 'eagles-sphere-finale',
    src: eaglesFinaleImage,
    alt: 'The Eagles name against a star field at the end of the Sphere concert',
    caption: 'The final title against the stars after the encore.',
  },
];

const u2StorySectionsWithMedia = u2StorySections.map((section) => {
  if (section.heading === 'Bigger Than the Band') {
    return {
      ...section,
      images: [
        { ...u2SphereCrewWithExospherePhoto, wide: true },
        {
          id: 'u2-sphere-crew-story',
          src: u2SphereCrewImage,
          alt: 'The Reckon crew beneath the U2 UV Achtung Baby Live at Sphere display',
          caption: 'The crew at Sphere for U2 in 2023.',
          wide: true,
        },
      ],
      imageAfterParagraph: section.paragraphs.length - 1,
    };
  }

  if (section.heading === 'Finally Inside') {
    return {
      ...section,
      images: [{ ...u2SphereArrivalClip, wide: true }],
      imageAfterParagraph: 2,
    };
  }

  if (section.heading === 'Section 405, Row 17') {
    return {
      ...section,
      images: [{ ...u2SphereSection405Photo, wide: true }],
      imageAfterParagraph: section.paragraphs.length - 1,
    };
  }

  if (section.heading === 'Sensory Overload') {
    return {
      ...section,
      images: [
        {
          id: 'u2-sphere-concert-story',
          src: u2SphereConcertImage,
          alt: 'U2 performing beneath an immersive display of birds and butterflies inside Sphere',
          caption: 'U2 surrounded by the immersive scale of Sphere.',
          wide: true,
        },
      ],
      imageAfterParagraph: section.paragraphs.length - 1,
    };
  }

  if (section.heading === 'The Fly') {
    return {
      ...section,
      images: [{ ...u2SphereTheFlyClip, wide: true }],
      imageAfterParagraph: section.paragraphs.length - 1,
    };
  }

  if (section.heading === 'Atomic City') {
    return {
      ...section,
      images: [{ ...u2SphereAtomicCityClip, wide: true }],
      imageAfterParagraph: section.paragraphs.length - 1,
    };
  }

  if (section.heading === 'Where the Streets Have No Name') {
    return {
      ...section,
      images: [{ ...u2SphereWhereStreetsClip, wide: true }],
      imageAfterParagraph: section.paragraphs.length - 1,
    };
  }

  return section;
});

const eaglesStorySectionsWithMedia = eaglesStorySections.map((section) => {
  if (section.heading === 'One More Night at Sphere') {
    return {
      ...section,
      images: [{ ...eaglesStoryGallery[0], wide: true }],
      imageAfterParagraph: section.paragraphs.length - 1,
    };
  }

  if (section.heading === 'Dinner Had Other Plans') {
    return {
      ...section,
      images: [{ ...eaglesStoryGallery[1], wide: true }],
      imageAfterParagraph: section.paragraphs.length - 1,
    };
  }

  if (section.heading === 'Hotel California Was Already Playing') {
    return {
      ...section,
      images: [{ ...eaglesStoryGallery[2], wide: true }],
      imageAfterParagraph: section.paragraphs.length - 1,
    };
  }

  if (section.heading === 'Written Across the Sky') {
    return {
      ...section,
      images: [{ ...eaglesStoryGallery[3], wide: true }],
      imageAfterParagraph: 0,
    };
  }

  if (section.heading === 'In the City') {
    return {
      ...section,
      imagePlacements: [
        {
          afterParagraph: 0,
          images: [{ ...eaglesStoryGallery[4], wide: true }],
        },
        {
          afterParagraph: 1,
          images: [{ ...eaglesStoryGallery[5], wide: true }],
        },
      ],
    };
  }

  if (section.heading === 'A Career Across the Walls') {
    return {
      ...section,
      images: [{ ...eaglesStoryGallery[6], wide: true }],
      imageAfterParagraph: 0,
    };
  }

  if (section.heading === 'The Encore') {
    return {
      ...section,
      images: [{ ...eaglesStoryGallery[7], wide: true }],
      imageAfterParagraph: section.paragraphs.length - 1,
    };
  }

  return section;
});

const whiskyStorySectionsWithMedia = whiskyStorySections.map((section) => {
  if (section.heading === 'Bringing the Attic to the Cosmopolitan') {
    return {
      ...section,
      imagePlacements: [
        {
          afterParagraph: 3,
          images: [{ ...whiskySuitePartyPhoto, wide: true }],
        },
        {
          afterParagraph: 4,
          images: [{ ...whiskyBalconyGlassPhoto, wide: true }],
        },
      ],
    };
  }

  if (section.heading === 'Whiskies From Around the World') {
    return {
      ...section,
      images: [
        {
          id: 'whiskies-of-the-world-bottles-story',
          src: whiskeysOfTheWorldImage,
          alt: 'A black-and-white lineup of whisky bottles selected for the tasting',
          caption: 'A tour through whiskies from around the world during AWS re:Invent 2024.',
          wide: true,
        },
        { ...whiskyBottleLineupClip, wide: true },
      ],
      imageAfterParagraph: section.paragraphs.length - 1,
    };
  }

  if (section.heading === 'Learning C-STEM') {
    return {
      ...section,
      images: [{ ...whiskyCstemTastingClip, wide: true }],
      imageAfterParagraph: section.paragraphs.length - 1,
    };
  }

  if (section.heading === 'Your Favorite Is Your Favorite') {
    return {
      ...section,
      images: [
        {
          id: 'whisky-tasting-crew-story',
          src: whiskeyTastingCrewImage,
          alt: 'The Reckon crew raising glasses together during the whisky tasting',
          caption: 'Raising a glass together during The Whisky Attic tasting.',
          wide: true,
        },
      ],
      imageAfterParagraph: section.paragraphs.length - 1,
    };
  }

  return section;
});

const years = [
  {
    year: 2022,
    attendees: ['Kevin L.', 'Brandon A.', 'Brandon L.', 'Marcus'],
    activities: ['ATV Tour in the Mojave Desert'],
    restaurants: ['STK', 'Amalfi by Bobby Flay', 'Bazaar Meat'],
    highlights: [
      'The beginning of Reckon’s recurring AWS re:Invent tradition',
      'ATV adventure in the Mojave Desert',
    ],
    status: 'published',
  },
  {
    year: 2023,
    attendees: ['Kevin L.', 'Brandon A.', 'Brandon L.', 'Marcus', 'Al', 'Matt'],
    activities: ['UTV Tour in the Mojave Desert', 'U2 at Sphere'],
    restaurants: ['STK', 'Catch', 'Bazaar Meat'],
    highlights: [
      'The Reckon Crew expanded',
      'First Reckon visit to Sphere',
      'U2 live at Sphere',
    ],
    status: 'published',
  },
  {
    year: 2024,
    attendees: ['Kevin L.', 'Brandon A.', 'Brandon L.', 'Marcus', 'Al', 'Jasmine', 'Ben', 'Matt'],
    activities: [
      'Jeep Off-Road Tour in Valley of Fire',
      'Hiking Zion National Park',
      'Eagles at Sphere',
      'Whiskeys of the World Tasting',
    ],
    restaurants: ['STK', 'Catch', 'Brezza', 'Golden Steer', 'Don’s Prime', 'Estiatorio Milos'],
    highlights: [
      'Largest Reckon AWS re:Invent crew to date',
      'Off-roading through Valley of Fire',
      'Hiking Zion National Park',
      'Eagles live at Sphere',
    ],
    status: 'published',
  },
  {
    year: 2025,
    attendees: ['Kevin L.', 'Marcus'],
    activities: [],
    restaurants: ['Jean-Georges Steakhouse'],
    highlights: [
      'A smaller return to Las Vegas',
      'Dinner at Jean-Georges Steakhouse',
    ],
    status: 'published',
  },
];

const activityMetadata = {
  'ATV Tour in the Mojave Desert': { category: 'Outdoor Adventure', meritBadgeSlug: 'atvs-mojave-desert' },
  'UTV Tour in the Mojave Desert': { category: 'Outdoor Adventure', meritBadgeSlug: 'utvs-mojave-desert' },
  'U2 at Sphere': { category: 'Live Entertainment', meritBadgeSlug: 'u2-at-sphere' },
  'Jeep Off-Road Tour in Valley of Fire': {
    entityId: 'jeep-off-road-tour-in-valley-of-fire-2024',
    category: 'Outdoor Adventure',
    meritBadgeSlug: 'valley-of-fire-off-roading',
  },
  'Hiking Zion National Park': { category: 'National Park', meritBadgeSlug: 'hiking-zion-national-park' },
  'Eagles at Sphere': { category: 'Live Entertainment', meritBadgeSlug: 'eagles-at-sphere' },
  'Whiskeys of the World Tasting': { category: 'Tasting Experience' },
};

const crewDirectory = {
  'Kevin L.': {
    slug: 'kevin-l', displayName: 'Kevin L.', title: 'Chief Executive Officer', headshot: kevinHeadshot,
  },
  'Brandon A.': {
    slug: 'brandon-a', displayName: 'Brandon A.', title: 'Co-Founder', headshot: brandonAHeadshot,
  },
  'Brandon L.': {
    slug: 'brandon-l', displayName: 'Brandon L.', title: 'Co-Founder', headshot: brandonLHeadshot,
  },
  Marcus: {
    slug: 'marcus-g', displayName: 'Marcus G.', title: 'Co-Founder', headshot: marcusHeadshot,
  },
  Al: {
    slug: 'al-m', displayName: 'Al M.', title: 'Reckon Crew Member', headshot: alHeadshot,
  },
  Matt: {
    slug: 'matt-g', displayName: 'Matt G.', title: 'Software Developer', headshot: mattHeadshot,
  },
  Jasmine: {
    slug: 'jasmine-b', displayName: 'Jasmine B.', title: 'Reckon Crew Member', headshot: jasmineHeadshot,
  },
  Ben: {
    slug: 'ben-b', displayName: 'Ben B.', title: 'Software Developer', headshot: benHeadshot,
  },
};

const activityDisplayMetadata = {
  'ATV Tour in the Mojave Desert': {
    description: 'Our first company conference adventure traded the Las Vegas Strip for a guided ATV ride across the Mojave Desert and helped establish a Reckon tradition.',
    whyWeWent: 'We wanted our first company conference trip to include something memorable beyond sessions and meetings, so the four co-founders left the Strip to try an adventure none of us had done before.',
    whatHappened: 'Best ATV Tours LV took us from the Luxor into the Mojave, where we learned the controls, followed the desert trails, and climbed a towering dune to a panoramic ridgeline.',
    whatWeRemember: 'This was more than an afternoon of off-roading. It became the first chapter of our tradition of building stronger teams through shared adventures.',
    storySections: [
      {
        heading: 'Why We Chose This Adventure',
        paragraphs: [
          'By 2022, I had attended AWS re:Invent enough times to know that while the conference itself was incredibly valuable, spending an entire week inside convention centers and on the Las Vegas Strip was not the experience I wanted our team to remember.',
          'This was the first conference trip Reckon had taken as a company. At the time, the team consisted solely of the four co-founders, Brandon A., Brandon L., Marcus, and me. It was the perfect opportunity to establish the kind of traditions we hoped would grow alongside the company.',
          'Rather than filling every hour with sessions and meetings, we intentionally carved out time to leave the city behind. We wanted to experience something completely different together, something none of us had ever done before. Riding ATVs through the Mojave Desert checked every box. It took us away from the noise of Las Vegas, put everyone on equal footing as beginners, and gave us the chance to create memories that had nothing to do with conference badges or keynote presentations.',
          'Looking back, this was not simply an afternoon of off-roading.',
          'It became the first chapter of a tradition that would eventually define The Reckon Way.',
        ],
      },
      {
        heading: 'Escaping the Strip',
        paragraphs: [
          'After attending a Wednesday morning session at AWS re:Invent, it was time to trade conference halls for open desert.',
          'The plan was simple. Meet at the Luxor Hotel at 10:45 a.m., where our tour shuttle would pick us up.',
          'I grabbed a taxi from the conference and arrived to find Brandon A. and Marcus already waiting outside.',
          'The only person missing was Brandon L.',
          'A quick text revealed the problem. He was somewhere inside the sprawling Luxor casino trying to find the correct exit. Like many first-time visitors to Las Vegas, he had discovered that getting through a casino can sometimes be more confusing than navigating the conference itself. After a few messages and some improvised directions, he finally emerged, and our crew was together.',
          'A white shuttle van with the Best ATV Tours LV logo pulled up to the curb. We climbed aboard, where our driver and guide, Alex, welcomed us before handing around a tablet so everyone could complete the required waivers.',
          'With the paperwork finished, we settled in for the roughly fifty-minute drive into the Mojave Desert.',
          'As the casinos disappeared in the rearview mirror, the city slowly gave way to wide-open desert.',
          'It felt like we were leaving one world behind and entering another.',
        ],
      },
      {
        heading: 'Base Camp',
        paragraphs: [
          'Eventually we pulled into what looked like a simple park-and-ride lot surrounded by miles of desert.',
          'There was not a visitor center or elaborate staging area. There was just a gravel lot, a row of ATVs parked beside a large trailer that had clearly delivered them before sunrise, and a smaller covered trailer where helmets, goggles, and gloves were handed out.',
          'Alex gathered us together for a safety briefing.',
          'He walked us through the controls, explained the hand signals we would use during the ride, and made sure everyone was comfortable before we headed onto the trail.',
          'Waiting for us were Tracker Off Road 450 ATVs.',
          'Climbing onto one immediately changed my perspective.',
          'These were not recreational toys.',
          'Each machine weighed around 600 pounds, and the moment I settled into the seat I realized this was going to be far more physical than I had imagined.',
          'One by one, the engines came to life, replacing the quiet desert with the deep rumble of four idling ATVs.',
          'After a short practice lap around the parking area to get comfortable with the controls, we lined up behind Alex at the trailhead.',
          'The pavement was behind us.',
          'Ahead stretched miles of Mojave Desert.',
        ],
      },
      {
        heading: 'Finding Our Rhythm',
        paragraphs: [
          'Alex eased onto the trail, and we followed in single file.',
          'Those first few minutes were spent somewhere between excitement and caution. None of us had driven an ATV before, and our immediate goal was not to go fast.',
          'It was simply to keep Alex in sight.',
          'The trail wound through deep sand, loose gravel, rocky washes, and rolling dunes. Every few minutes the terrain changed, demanding something different from both the rider and the machine.',
          'Each ATV carried an eight-foot safety flag mounted behind the seat.',
          'Ironically, we rarely noticed it.',
          'The easiest way to follow Alex was not the flag. It was the enormous cloud of dust his ATV kicked into the air. That drifting trail of sand became our guide through the desert.',
          'At first, Alex looked back every few seconds to make sure everyone was still with him.',
          'As we grew more comfortable, something changed.',
          'Those quick glances became full inspections.',
          'He would stand on the foot pegs, twist completely around, steer with one hand, and somehow continue weaving through the trail without ever looking where he was going.',
          'Meanwhile, I was gripping the handlebars with both hands, completely focused on staying upright.',
          'My only thought was: "What a show off."',
          'Looking back, it was not showing off at all.',
          'It was experience.',
          'Alex had probably driven these trails hundreds of times.',
          'To four first-time riders, though, it looked almost effortless.',
        ],
      },
      {
        heading: 'A Break in the Desert',
        paragraphs: [
          'After twenty or thirty minutes of riding, Alex led us to a stop beside a large rock outcrop that offered one of the few patches of shade for miles.',
          'We shut off the engines and removed our helmets.',
          'The silence was almost startling after the constant rumble of the ride.',
          'Although the desert sun was bright, the late-November air was surprisingly chilly. Standing in the shade, you could definitely feel it. Step back into the sunlight, and the warmth immediately returned.',
          'We grabbed bottles of water and spent a few minutes taking in the landscape.',
          'Mountains stretched across the horizon.',
          'Trails disappeared into sand and rock.',
          'There was not another group in sight.',
          'It was hard to believe that less than two hours earlier we had been surrounded by tens of thousands of people inside one of the world\'s largest technology conferences.',
          'Now it was just five people standing in the middle of the Mojave Desert.',
          'As we finished our water and started putting our helmets back on, Alex smiled.',
          '"The ride out here was just the warm-up."',
          'Then he added, "Now we\'re really going to fly."',
        ],
      },
      {
        heading: 'The Dune',
        paragraphs: [
          'The pace immediately picked up.',
          'We carved through a series of sweeping S-curves between rolling sand dunes, each turn faster than the last. By now, we trusted both the ATVs and ourselves. Instead of thinking about the controls, we were simply enjoying the ride.',
          'Then we rounded one final corner.',
          'Directly in front of us stood the largest sand dune I had ever seen.',
          'It looked more like a mountain than a dune.',
          'The trail climbed straight toward it before disappearing over the top.',
          'Alex pulled off to the right side of the trail and motioned for us to pass.',
          'No explanation.',
          'No stopping.',
          'Just the unmistakable signal to go.',
          'We all understood exactly what he meant.',
          'One by one, we accelerated toward the base of the dune.',
          'The engines roared as the ATVs dug into the soft sand.',
          'At first the climb felt easy.',
          'Then the incline grew steeper.',
          'The ATV slowed.',
          'For a moment I wondered if it was actually going to make it.',
          'It never stopped.',
          'Foot by foot, it continued climbing.',
          'The ascent felt endless.',
          'Then, almost without realizing it, the front wheels reached the crest.',
          'The ATV leveled out.',
          'Suddenly, the entire Mojave Desert opened before us.',
          'Miles of rolling dunes, rugged mountains, and winding trails stretched in every direction.',
          'We parked along the ridgeline and simply stood there for a few minutes, taking it all in.',
          'A few moments later, Alex made the same climb we had just conquered.',
          'What had felt monumental to us looked completely effortless for him.',
          'After one last look across the desert, we climbed back onto our ATVs.',
          'Five minutes later, we rolled back into the parking lot where the adventure had begun.',
        ],
      },
      {
        heading: 'The Ride Home',
        paragraphs: [
          'We returned our helmets, goggles, and gloves, climbed back into the shuttle, and started the drive toward Las Vegas.',
          'Only then did we fully appreciate what we had just done.',
          'Every one of us was covered in a fine layer of Mojave dust.',
          'It clung to our clothes, our shoes, our backpacks, and somehow found its way into every crease imaginable. There was no hiding where we had spent the afternoon.',
          'As the adrenaline wore off, another realization began to set in.',
          'I was sore.',
          'Not just tired, but the kind of sore you feel after a really good workout. My shoulders, arms, and upper body had spent the afternoon wrestling a 600-pound ATV across sand, gravel, and rock. Driving one was far more physical than I ever would have guessed.',
          'As we followed the dirt road from the staging area toward the highway, Alex suddenly slowed the shuttle and pulled off to the side.',
          '"Come check this out."',
          'We climbed out and gathered around as he pointed to a large desert spider making its way across the ground.',
          'It was a simple moment, but one that reminded us we had spent the afternoon riding through a real desert ecosystem, not just an off-road course built for tourists.',
          'Marcus stared at it for a second before saying, "If I\'d known those things were out here roaming around, I\'m not sure I would have done it."',
          'The van erupted in laughter.',
          'It was the perfect ending to the day.',
          'Before long, we were back on the highway, watching the Mojave slowly disappear in the rearview mirror as the Las Vegas skyline came back into view.',
          'We returned to AWS re:Invent a little dustier, a little sorer, and carrying a story we would still be laughing about years later.',
        ],
      },
      {
        heading: 'Looking Back',
        paragraphs: [
          'At the time, this was simply an afternoon away from AWS re:Invent.',
          'Looking back, it became much more than that.',
          'It established a tradition that continues to shape Reckon today.',
          'Every major conference and every corporate retreat now includes time to step away from the agenda and share an experience together. Sometimes that is hiking through Zion National Park. Sometimes it is driving Jeeps through the Valley of Fire, snowmobiling across an Icelandic glacier, sailing in the Caribbean, or exploring a city we had never seen before.',
          'The adventure itself changes.',
          'The purpose never does.',
          'Shared adventures create shared stories.',
          'Shared stories build stronger teams.',
          'The Mojave Desert was where we first discovered that.',
          'Looking back, this was not just Reckon\'s first ATV ride.',
          'It was the first chapter of The Reckon Way.',
        ],
      },
    ],
    images: [
      {
        src: vegas2022Atv5314Image,
        alt: 'A Reckon crew member standing beside the ATVs during the 2022 Mojave Desert tour',
        position: 'center center',
      },
      {
        src: vegas2022Atv5315Image,
        alt: 'A Reckon crew member seated on an ATV in the Mojave Desert',
        position: 'center center',
      },
      {
        src: vegas2022Atv5318Image,
        alt: 'A Reckon crew member taking a break beside the ATVs in the Mojave Desert',
        position: 'center center',
      },
    ],
    websiteUrl: 'https://bestatvtourslv.com/',
  },
  'UTV Tour in the Mojave Desert': {
    description: 'Our second Mojave off-road adventure put six Reckon drivers behind the wheels of Can-Am Maverick X3 UTVs for more than thirty miles of desert trails.',
    whyWeWent: 'The ATV ride in 2022 had already become a highlight and the beginning of a Reckon tradition, so we returned in 2023 with more of the team ready to experience the desert together.',
    whatHappened: 'Las Vegas Elite Offroad led us on an extended two-hour drive through washes, rock gardens, dunes, and blind ridgelines, with everyone chasing 50 mph whenever the trail opened up.',
    whatWeRemember: 'The speed and climbs became one long rush, but Al calling his son afterward to say they had to return together captured why these shared adventures matter.',
    storySections: [
      {
        heading: 'A Tradition Worth Repeating',
        paragraphs: [
          'When we returned to AWS re:Invent in 2023, there wasn\'t much debate about what we\'d do outside the conference.',
          'The year before, four of us escaped the Las Vegas Strip for an ATV adventure through the Mojave Desert. What started as a way to get away from the conference had become one of the highlights of the trip and the beginning of a new Reckon tradition.',
          'This year, we weren\'t discovering it for the first time.',
          'We were bringing more of the team along.',
          'Joining us were Al and Matt, both experiencing one of our conference adventures for the first time. Along with Kevin, Marcus, Brandon A., and Brandon L., the six of us were ready to trade conference rooms for desert trails.',
          'Our adventure was scheduled for Thursday afternoon with pickup at the MGM Grand.',
          'Everyone met a little early, and before boarding the shuttle we wandered across Las Vegas Boulevard into New York-New York looking for breakfast. After walking around for a few minutes, we settled on a small crêpe shop. It wasn\'t a destination anyone would normally seek out, but those simple moments often become part of the story. Sitting around breakfast before an adventure has become just as much a tradition as the adventure itself.',
          'Outside the hotel, our shuttle from Las Vegas Elite Offroad was waiting.',
          'About fifteen minutes later we arrived at what looked like an ordinary industrial park near Nellis Air Force Base and the Las Vegas Motor Speedway. If you drove by, you\'d never guess this was where the afternoon\'s adventure would begin.',
          'Inside, we checked in, signed our waivers, and listened as our guides, Brandon and Dylan, walked everyone through the safety briefing. Helmets, goggles, and headsocks were handed out before we climbed back onto the shuttle for one final ride to the trailhead.',
          'When we stepped off the bus, a lineup of Can-Am Maverick X3 UTVs was waiting for us.',
          'Everything about them looked more serious than the ATVs we\'d driven the year before.',
          'Wide stance.',
          'Long-travel suspension.',
          'Aggressive tires.',
          'Full roll cages.',
          'These weren\'t machines built to casually explore the desert.',
          'They were built to attack it.',
          'Our convoy consisted of eight UTVs.',
          'Brandon led the group.',
          'Dylan brought up the rear.',
          'Between them were six Reckon drivers, each with a Maverick X3 of their own.',
          'Unlike many off-road tours where passengers ride together, everyone was behind the wheel.',
          'This time we\'d booked the extended tour.',
          'Nearly two hours of driving.',
          'About an hour into the Mojave.',
          'A short break.',
          'Then nearly another hour back along an entirely different route.',
          'More than thirty miles of desert lay ahead.',
        ],
      },
      {
        heading: 'Chasing Fifty',
        paragraphs: [
          'The biggest difference became obvious almost immediately.',
          'Speed.',
          'The ATVs had been fun.',
          'These were something else.',
          'As soon as Brandon pulled onto the trail, the pace picked up.',
          'The Maverick X3s seemed perfectly at home in the Mojave. They floated across terrain that would have rattled us around the year before. The suspension absorbed washboards, rocks, and ruts while the turbocharged engines always seemed to have more to give.',
          'The terrain constantly changed.',
          'Dry washes.',
          'Rock gardens.',
          'Open desert.',
          'Steep dunes.',
          'Every few minutes the landscape became something completely different.',
          'Whenever the trail opened up, everyone had the same goal.',
          'Hit fifty.',
          'We all found ourselves sneaking glances at the speedometer, hoping to see it climb past 50 mph before the next turn, wash, or hill demanded our attention.',
          'Later that evening, one of the first conversations we had wasn\'t about the conference.',
          'It was comparing top speeds.',
          'Not because it mattered.',
          'Because every one of us had been trying to do the exact same thing all afternoon.',
        ],
      },
      {
        heading: 'Trust the Crest',
        paragraphs: [
          'More than anything else, I remember the climbs.',
          'Not one particular hill.',
          'All of them.',
          'The desert rolled endlessly through dunes and ridgelines, and every blind crest brought the same feeling.',
          'The UTV ahead of you would begin climbing.',
          'Then disappear.',
          'For a few seconds, all you could see through the windshield was blue sky.',
          'You couldn\'t see the trail.',
          'You couldn\'t see Brandon.',
          'You couldn\'t see the driver in front of you.',
          'All you could do was trust that the guide had picked the right line, trust that the person ahead of you hadn\'t stopped, and keep your foot on the throttle.',
          'The Maverick would claw its way up the hill.',
          'The engine would pull.',
          'Then suddenly you\'d crest the ridge and the desert would open up in front of you once again.',
          'There was Brandon.',
          'Already leading us toward the next challenge.',
          'That feeling repeated itself over and over again throughout the afternoon.',
          'Every climb carried the same split second of uncertainty followed by the rush of seeing the trail stretch back out before you.',
        ],
      },
      {
        heading: 'A Moment of Quiet',
        paragraphs: [
          'About an hour into the ride, we stopped for a break.',
          'The engines fell silent.',
          'Helmets came off.',
          'Goggles were pushed onto foreheads.',
          'Cold drinks never tasted so good.',
          'Standing in the middle of the Mojave, the silence was almost surprising.',
          'Then it was broken by the unmistakable sound of military jets overhead.',
          'If memory serves, they were a pair of F-22 Raptors from nearby Nellis Air Force Base, roaring across the desert before disappearing into the distance.',
          'It was one of those moments you couldn\'t have planned.',
          'A few minutes later, the helmets went back on, the engines came to life, and we headed out again.',
          'The return trip followed an entirely different set of trails, making the second hour feel like a brand-new adventure instead of simply retracing our steps.',
        ],
      },
      {
        heading: 'One Long Rush',
        paragraphs: [
          'Looking back, this adventure feels different than our first trip into the Mojave.',
          'The ATV ride is easy to replay in my mind.',
          'I remember specific trails.',
          'Specific conversations.',
          'Specific moments.',
          'This one is different.',
          'The memories blur together.',
          'Not because it wasn\'t memorable.',
          'Because it was so immersive.',
          'What I remember is the feeling.',
          'The speed.',
          'The dust.',
          'The vibration.',
          'The constant focus of reading the terrain while trying to keep pace with Brandon and Dylan.',
          'Two hours.',
          'More than thirty miles.',
          'A blur of washes, rocks, dunes, and open desert.',
          'It wasn\'t one unforgettable moment.',
          'It was two hours of them.',
        ],
      },
      {
        heading: 'The Ride Home',
        paragraphs: [
          'On the shuttle back to the MGM Grand, everyone compared speeds, laughed about the climbs, and replayed their favorite sections of the trail.',
          'One moment has stayed with me more than any other.',
          'Al pulled out his phone and called his son.',
          '"You\'ll never believe what I just did."',
          'A few moments later he smiled and said,',
          '"We have to come back and do this together."',
          'That conversation captured exactly why we started adding adventures to our conference trips.',
          'The UTVs were incredible.',
          'The desert was unforgettable.',
          'But hearing someone immediately think about sharing the experience with his family reminded me what these trips are really about.',
          'Great experiences don\'t end when you take off your helmet.',
          'They become stories.',
          'Stories become traditions.',
          'Traditions become culture.',
          'Looking back, our second trip into the Mojave wasn\'t simply a faster version of the first.',
          'It was the moment we realized this wasn\'t becoming a Reckon tradition.',
          'It already was.',
        ],
      },
    ],
    images: [
      {
        src: utvCrewGroupImage,
        alt: 'The Reckon crew gathered around blue UTVs in the Mojave Desert',
        position: 'center center',
      },
      {
        src: utvDriverImage,
        alt: 'A helmeted Reckon crew member seated behind the wheel of a blue UTV',
        position: 'center center',
      },
      {
        src: utvTrailBreakImage,
        alt: 'The Reckon crew taking a break together on the Mojave Desert trail',
        position: 'center center',
      },
      {
        src: utvGearUpImage,
        alt: 'The Reckon crew gearing up with helmets before the UTV tour',
        position: 'center center',
      },
      {
        src: utvTrailBriefingImage,
        alt: 'The Reckon crew listening to the UTV trail briefing in the Mojave Desert',
        position: 'center center',
      },
      {
        src: utvDriverViewImage,
        alt: 'A driver\'s view from inside a UTV looking across the Mojave Desert',
        position: 'center center',
      },
      {
        src: utvBehindTheWheelImage,
        alt: 'A helmeted Reckon crew member behind the wheel of a UTV',
        position: 'center center',
      },
    ],
    websiteUrl: 'https://www.lasvegaseliteoffroad.com/',
  },
  'U2 at Sphere': {
    description: 'U2 brought Achtung Baby to life inside Sphere, turning the Reckon crew\'s first visit to the venue into a race from the final song to a 12:58 a.m. flight home.',
    dayLabel: 'December 2023',
    location: 'Las Vegas, Nevada',
    whyWeWent: 'Sphere had opened only a few months earlier, and U2 was in the middle of its groundbreaking U2:UV Achtung Baby Live at Sphere residency. We were already in Las Vegas for AWS re:Invent, and there was no way we were going to miss it.',
    whatHappened: 'After a slow journey through the Venetian and up to Section 405, Row 17, we watched Sphere transform around U2. Then we raced through Las Vegas to collect our luggage and catch a 12:58 a.m. red-eye home.',
    whatWeRemember: 'The impossible virtual ceiling, the clarity of the sound, Las Vegas deconstructing during Atomic City, the world opening during Where the Streets Have No Name, and discovering that we had exactly enough time to make our flight.',
    storySections: u2StorySectionsWithMedia,
    relatedMediaIds: ['u2-sphere-crew-2023', 'u2-sphere-concert-2023'],
    images: [
      u2SphereCrewWithExospherePhoto,
      {
        src: u2SphereCrewImage,
        alt: 'The Reckon crew beneath the U2 UV Achtung Baby Live at Sphere display',
        position: 'center center',
      },
      u2SphereSection405Photo,
      {
        src: u2SphereConcertImage,
        alt: 'U2 performing beneath an immersive display of birds and butterflies inside Sphere',
        position: 'center center',
      },
    ],
    videos: [
      u2SphereArrivalClip,
      u2SphereTheFlyClip,
      u2SphereAtomicCityClip,
      u2SphereWhereStreetsClip,
    ],
  },
  'Jeep Off-Road Tour in Valley of Fire': {
    images: valleyOfFireGallery,
    websiteUrl: 'https://lasvegasrockcrawlers.com/',
  },
  'Hiking Zion National Park': {
    description: 'Three hikes, one unforgettable day in Zion National Park, with the road to Springdale, a star-filled first night, and a guided journey through the canyon all part of the story.',
    dayLabel: 'November 30–December 1, 2024',
    location: 'Zion National Park and Springdale, Utah',
    whyWeWent: 'Zion had been on our bucket list for years, and our annual AWS re:Invent trip finally put the Reckon crew within a few hours of the canyon.',
    whatHappened: 'With our guide Samantha, we climbed to Scout Lookout, followed the Virgin River on Riverside Walk, and raced the sunset up Watchman Trail.',
    whatWeRemember: 'The views were unforgettable, but so were the quieter moments: dinner in Springdale, stars over the hotel, a homemade trail lunch, and reaching every overlook together.',
    storyPages: zionStoryPages,
    storyLinks: [
      { label: 'Read Overview', storyPageSlug: 'overview' },
      { label: 'Read Day 1', storyPageSlug: 'day-1' },
      { label: 'Read Day 2', storyPageSlug: 'day-2' },
    ],
    images: zionHikeGallery,
    videos: [
      {
        id: 'zion-hike-video-100612',
        firebaseAssetId: 'zion-hike-video-100612',
        type: 'video',
        mimeType: 'video/mp4',
        captionsSrc: '/captions/aws-reinvent-2024-zion-hike-100612.vtt',
        alt: 'Hiking the Zion National Park trail during AWS re:Invent 2024',
        title: 'On the Trail in Zion',
      },
      {
        id: 'zion-hike-video-130042',
        firebaseAssetId: 'zion-hike-video-130042',
        type: 'video',
        mimeType: 'video/mp4',
        captionsSrc: '/captions/aws-reinvent-2024-zion-hike-130042.vtt',
        alt: 'Zion National Park trail views during AWS re:Invent 2024',
        title: 'Zion Trail Views',
      },
    ],
    websiteUrl: 'https://wildlandtrekking.com/',
  },
  'Eagles at Sphere': {
    description: 'A late arrival during Hotel California led into a career-spanning Eagles show that used Sphere as a different world for nearly every song.',
    dayLabel: '12/6/2024',
    location: 'Las Vegas, Nevada',
    whyWeWent: 'After seeing U2 at Sphere in 2023, we wanted to return with the larger 2024 AWS re:Invent crew and see how the Eagles would shape the venue around their catalog.',
    whatHappened: 'Dinner at Estiatorio Milos ran long, so we entered during Hotel California, climbed to Section 406, Row 13, and watched Sphere move from desert highways and handwritten stars to a twisting city, underwater swimmers, and a Las Vegas drive.',
    whatWeRemember: 'The Eagles used the room more consistently than U2 had the year before: a slower, more relaxed crowd, pristine harmonies, and a distinct visual world serving nearly every song.',
    storySections: eaglesStorySectionsWithMedia,
    relatedMediaIds: eaglesStoryGallery.map((image) => image.id),
    images: eaglesStoryGallery,
  },
  'Whiskeys of the World Tasting': {
    description: 'A worldwide whisky tasting in a Cosmopolitan wraparound suite taught us C-STEM, introduced us to unexpected favorites, and ended with a surprise Macallan 18 before a run to Brezza.',
    dayLabel: 'December 2024',
    location: 'The Cosmopolitan of Las Vegas, Las Vegas, Nevada',
    whyWeWent: 'Kevin wanted to bring the lesson he first learned at The Whisky Attic above the Freakin\' Frog to the Reckon crew and friends gathered during AWS re:Invent.',
    whatHappened: 'JD brought whiskies from around the world to the suite, taught Adam Carmer\'s C-STEM method, and helped everyone discover a personal tasting profile before Kevin opened a surprise bottle of The Macallan 18 Double Cask.',
    whatWeRemember: 'Chill music, friends moving between the suite and balcony, Indri and Jura emerging as Kevin\'s favorites, the lesson that price does not decide preference, and finishing the final pour just in time to run to Brezza.',
    storySections: whiskyStorySectionsWithMedia,
    relatedMediaIds: [
      'whiskeys-of-the-world-bottles',
      'whiskeys-of-the-world-crew',
      'whisky-suite-party',
      'whisky-balcony-glass',
      'whisky-tasting-video-bottles',
      'whisky-tasting-video-cstem',
    ],
    images: [
      {
        src: whiskeyTastingCrewImage,
        alt: 'The Reckon crew raising glasses together during the whisky tasting',
        position: 'center center',
      },
      {
        src: whiskeysOfTheWorldImage,
        alt: 'A black-and-white lineup of whisky bottles selected for the tasting',
        position: 'center bottom',
      },
      whiskySuitePartyPhoto,
      whiskyBalconyGlassPhoto,
    ],
    videos: [
      whiskyBottleLineupClip,
      whiskyCstemTastingClip,
    ],
    websiteUrl: 'https://www.whiskyattic.com/',
  },
};
const activities = getRecurringActivities(years, activityMetadata).map((activity) => ({
  ...activity,
  ...(activityDisplayMetadata[activity.title] || {}),
}));
const restaurantMetadata = {
  STK: {
    titleOverride: 'STK Las Vegas',
    description: 'Our first-night AWS re:Invent tradition pairs STK’s high-energy dining room with an easy walk to the Chandelier Bar inside our Cosmopolitan home base.',
    dayLabel: 'AWS re:Invent 2022–2024',
    location: 'The Cosmopolitan of Las Vegas, Las Vegas, Nevada',
    whyWeWent: 'STK brought everyone together without leaving The Cosmopolitan after a day of travel, making it the perfect place to begin AWS re:Invent week.',
    whatHappened: 'The crew gathered around steaks, drinks, loud music, a DJ spinning hits, and Brandon A.’s reliably ordered Brussels sprouts before wandering over to the Chandelier Bar.',
    whatWeRemember: 'The ritual became the point: fly into Las Vegas, check into the Cosmo, meet downstairs at STK, then people-watch at the Chandelier Bar while the entire week was still ahead of us.',
    storySections: [
      {
        heading: 'The Reckon Connection',
        paragraphs: [
          'STK wasn’t new to me when we started coming to Las Vegas for AWS re:Invent.',
          'I’d been there plenty of times before, including hosting a company event there with my previous company. I’d always enjoyed the food, but there are plenty of places in Las Vegas to get a great steak.',
          'What always brought me back to STK was the energy.',
          'STK doesn’t really feel like a traditional steakhouse. There’s a DJ spinning hits, the music is turned up, the room is moving, and dinner feels like the beginning of a night out rather than the end of one.',
          'And then there’s the Cosmo itself.',
          'The Cosmopolitan has always had a darker, sexier feel than most of the big Las Vegas resorts. STK fits right into that.',
          'More importantly, the Cosmo became our home base for AWS re:Invent, and STK is right there.',
          'We usually arrive in Las Vegas on the first day of the trip. It’s primarily a travel day. Everyone has flown in, checked into their rooms, dropped their bags, and is settling into Vegas before AWS re:Invent really gets going.',
          'STK became the perfect way to bring everyone together and start the week.',
          'No figuring out transportation. No trying to get the whole crew across the Strip after a day of traveling. We could get checked in, regroup, head downstairs, and suddenly everyone was around the same table.',
          'Good steaks. Drinks. Loud music. A DJ spinning hits. The energy of the Cosmo all around us.',
          'And, because Brandon A. was at the table, apparently we were ordering the Brussels sprouts.',
          'It became one of those little running jokes that probably wouldn’t mean anything to anyone outside the group. Somehow, whenever we were ordering sides, Brandon A. made sure the Brussels sprouts were represented.',
          'Steakhouse in Las Vegas?',
          'Brussels sprouts.',
          'Every time.',
          'And dinner didn’t necessarily mean the night was over.',
          'STK’s location made it easy to wander over to the Chandelier Bar afterward, grab another drink, and settle in for some of the best people-watching in Vegas.',
          'There was nowhere else we needed to be.',
          'AWS re:Invent hadn’t really started yet. Everyone had made it to town, and the week was still completely ahead of us.',
          'After the first year, we came back.',
          'Then we came back again.',
          'At some point, without ever really deciding that it was going to be one, STK became our first-night tradition.',
          'It’s not necessarily about STK being the best steakhouse in Las Vegas.',
          'It’s about the ritual.',
          'Fly into Vegas. Check into the Cosmo. Drop the bags upstairs. Meet downstairs at STK. Order the steaks and, of course, Brandon A.’s Brussels sprouts.',
          'Then wander over to the Chandelier Bar, have a drink, watch Vegas go by, and enjoy that first night when the entire week is still ahead of us.',
          'It’s how we know we’ve arrived.',
          'And AWS re:Invent is about to begin.',
        ],
      },
    ],
    image: stkDinner2024Image,
    imageAlt: 'The Reckon crew gathered around the dinner table at STK Las Vegas in 2024',
    imagePosition: 'center center',
    websiteUrl: 'https://stksteakhouse.com/en-us/location/las-vegas/',
  },
  'Amalfi by Bobby Flay': {
    description: 'What began as a plan for something lighter became a shared feast of market-fresh seafood and Steak Florentine. It may have changed how the Reckon crew eats together.',
    dayLabel: 'AWS re:Invent 2022',
    location: 'Caesars Palace, Las Vegas, Nevada',
    whyWeWent: 'With STK and Bazaar Meat already covering steak during the first Reckon AWS re:Invent trip, Amalfi promised fresh seafood and a lighter change of pace.',
    whatHappened: 'The four-person crew met at the bar, toured the seafood market, and asked the restaurant to choose a shared meal that ultimately included both fresh fish and an unforgettable Steak Florentine.',
    whatWeRemember: 'The seafood display on barrels of ice, the plan for a lighter dinner giving way to a great steak, and discovering a communal way of dining that became a Reckon tradition.',
    storySections: [
      {
        heading: 'Something Lighter',
        paragraphs: [
          'It was our first Reckon trip to AWS re:Invent in 2022, and there were only four of us.',
          'We’d already built a pretty serious restaurant lineup for the week.',
          'STK.',
          'Bazaar Meat.',
          'We clearly had steak covered.',
          'So when we chose Amalfi at Caesars Palace, part of the thinking was that we’d give ourselves a break and do something a little lighter.',
          'Seafood.',
          'Fresh fish.',
          'Maybe balance out some of the meat we were going to eat that week.',
          'Or so we thought.',
        ],
      },
      {
        heading: 'Meet at the Bar',
        paragraphs: [
          'Like most days during AWS re:Invent, we’d spent the day in different places. Different sessions, different meetings, different parts of the Strip.',
          'Dinner was where we came back together.',
          'That night, the meeting point was the bar at Amalfi.',
          'The restaurant sits just off the casino floor at Caesars Palace, so even though the dining room itself wasn’t particularly crowded that night, it didn’t feel quiet.',
          'Vegas was right there.',
          'You could feel the energy of the casino just outside the restaurant. People moving through Caesars, machines going, the constant background noise of the casino floor.',
          'One by one, we found our way to the bar.',
          'Grab a drink.',
          'Figure out who was still on the way.',
          'Then, once all four of us had made it, head to the table.',
          'We thought we were just meeting for dinner.',
          'Looking back, this may have been the night we figured out one of our favorite ways to eat together.',
        ],
      },
      {
        heading: 'Just Feed Us',
        paragraphs: [
          'Somewhere along the way at Amalfi, we decided not to overthink the menu.',
          'Instead of four people studying every option and ordering four individual meals, we put ourselves in the hands of the restaurant.',
          'Tell us what’s good.',
          'Show us what we shouldn’t leave without trying.',
          'Just start bringing it out.',
          'It sounds pretty normal to us now because we’ve done it so many times since.',
          'At the time, it was something new.',
        ],
      },
      {
        heading: 'Start With the Fish',
        paragraphs: [
          'The staff didn’t just tell us what seafood they recommended.',
          'They got us up from the table.',
          'We walked over to Amalfi’s seafood display, where the fresh fish were laid out in barrels of ice.',
          'The staff walked us through what was available, showed us the fish they recommended, and talked about what the kitchen could do with them.',
          'That immediately changed the experience.',
          'We weren’t choosing between descriptions printed on a menu anymore.',
          'We were standing there looking at the actual fish that was about to become dinner.',
          'Then we went back to the table and let them take it from there.',
        ],
      },
      {
        heading: 'So Much for Something Lighter',
        paragraphs: [
          'For a seafood-focused restaurant, one of the things I remember most clearly wasn’t seafood at all.',
          'The Steak Florentine.',
          'Apparently our plan to eat something lighter hadn’t survived contact with the kitchen.',
          'The steak arrived as part of the meal the restaurant had put together for us, and it was amazing.',
          'And honestly, nobody complained.',
          'That’s what made giving up control of the menu so much fun.',
          'We hadn’t gone into Amalfi planning to order another big steak. We’d specifically chosen the restaurant because STK and Bazaar Meat already had that part of the week covered.',
          'But we’d also told the restaurant to show us what we shouldn’t miss.',
          'Apparently, we shouldn’t miss the Steak Florentine.',
          'They were right.',
          'The table got to experience all of it.',
          'Fresh seafood we’d just seen sitting on ice.',
          'A great Steak Florentine.',
          'Different dishes arriving for everyone to share.',
          'Instead of four separate dinners happening at the same table, we were all having the same dinner together.',
        ],
      },
      {
        heading: 'Something That Stuck',
        paragraphs: [
          'At the time, I don’t think any of us thought we were starting a tradition.',
          'We’d simply found a fun way to experience a restaurant.',
          'But we kept doing it.',
          'Over the years, the restaurants changed. The size of the crew changed. Sometimes friends from the industry joined us. The food could be Italian, seafood, sushi, steak, or whatever the chef wanted to put in front of us.',
          'But the basic idea stayed remarkably similar.',
          'You know your restaurant better than we do. Show us why we came.',
          'It changed the way we experienced dinner together.',
          'When everyone orders separately, four people can sit at the same table and essentially have four different meals.',
          'When the restaurant takes over, everyone is waiting for the same next dish.',
          'Everyone tries it.',
          'Everyone has an opinion.',
          'And everyone experiences the meal together.',
          'I think Amalfi may have been where we first figured that out.',
          'Four of us meeting at a bar just off the casino floor at Caesars Palace during our first AWS re:Invent trip.',
          'We’d chosen seafood because we thought we needed something lighter.',
          'We ended up with fresh fish and an amazing Steak Florentine.',
          'And somewhere along the way, we discovered a new way to share a meal.',
        ],
      },
    ],
    image: vegas2022Amalfi5383Image,
    imageAlt: 'The Reckon crew visiting the seafood market at Amalfi by Bobby Flay in 2022',
    imagePosition: 'center center',
    websiteUrl: 'https://www.caesars.com/caesars-palace/restaurants/amalfi',
  },
  'Bazaar Meat': {
    description: 'Bazaar Meat turned dinner into a show through imaginative opening bites, tableside-carved steak, and a location that made it the perfect prelude to AWS re:Play.',
    dayLabel: 'AWS re:Invent 2022–2023',
    location: 'SAHARA Las Vegas, Las Vegas, Nevada',
    whyWeWent: 'Kevin already knew Bazaar Meat could surprise the crew, and its location across from the Las Vegas Festival Grounds made it an ideal Thursday dinner before AWS re:Play.',
    whatHappened: 'Four founders handed the 2022 meal over to the server, while a much larger 2023 group shared a prix fixe tasting menu built around signature bites and bone-in strip loin carved tableside.',
    whatWeRemember: 'Cotton candy foie gras, the steak arriving as the true star, friends from the industry pulling up more chairs, and crossing the street together for AWS re:Play.',
    storySections: [
      {
        heading: 'The Reckon Connection',
        paragraphs: [
          'Bazaar Meat wasn’t a discovery for me.',
          'I’d been there before and had even arranged a corporate dinner there in the past, so when we were planning our first AWS re:Invent trip in 2022, I already knew exactly what we were getting into.',
          'More importantly, I knew the rest of the crew didn’t.',
          'Bazaar Meat isn’t the kind of steakhouse where you simply order a steak, eat it, and leave. The kitchen, the grills, the meat displays, and the presentation are all part of the experience.',
          'I knew some of what was coming.',
          'They didn’t.',
          'And I was pretty sure it was going to blow their minds.',
          'There was also a practical reason it fit perfectly into our AWS re:Invent week.',
          'Thursday night is AWS re:Play, the big end-of-conference party at the Las Vegas Festival Grounds. Bazaar Meat was right across the street.',
          'That gave us a pretty simple plan.',
          'Early dinner at Bazaar Meat.',
          'Then head across the street and finish AWS re:Invent at AWS re:Play.',
        ],
      },
      {
        heading: 'Four People and a Table Full of Food',
        paragraphs: [
          'Our first Reckon dinner there in 2022 was small.',
          'There were only four of us.',
          'With a table that size, we didn’t need to overthink it. We essentially put ourselves in the server’s hands and asked them to start bringing out the signature dishes they thought we needed to experience.',
          'That’s one of my favorite ways to eat at a restaurant like this.',
          'Don’t make us figure it out.',
          'Show us why people come here.',
          'What followed was less like ordering dinner and more like letting the restaurant put on a show.',
          'Different dishes arrived for everyone to share. Some were familiar ingredients presented in completely unfamiliar ways. Others were designed to get a reaction before anyone even took the first bite.',
          'That was exactly why I’d wanted to bring everyone there.',
        ],
      },
      {
        heading: 'The Show Before the Steak',
        paragraphs: [
          'The cotton candy foie gras was probably the best example.',
          'It’s one of those dishes that gets everyone’s attention as soon as it reaches the table. Foie gras and cotton candy aren’t exactly an obvious combination, and the presentation alone was enough to get people talking.',
          'The good news was that it wasn’t just a gimmick.',
          'It was actually really good.',
          'But as memorable as some of those opening dishes were, they weren’t the reason to come to a place called Bazaar Meat.',
          'Eventually, the steak arrived.',
          'The real star for us was the bone-in strip loin, brought to the table and carved right there in front of us.',
          'That’s the kind of presentation I remembered from my previous visits and part of why I wanted to bring the crew in the first place. A big piece of perfectly cooked beef arrives, the carving happens tableside, and suddenly everyone is reaching toward the same platter.',
          'For all the creativity and theater that came before it, Bazaar Meat still delivered where it mattered most.',
          'The steak was the star.',
        ],
      },
      {
        heading: 'A Much Bigger Table',
        paragraphs: [
          'When we returned in 2023, the dinner looked very different.',
          'Reckon’s AWS re:Invent group had grown, and along the way we’d met up with some other people we knew from our industry who were also in town for the conference.',
          'So we invited them to dinner.',
          'We had gone from four of us around the table in 2022 to a much larger group in 2023.',
          'With a group that size, simply turning ourselves over to the server and seeing what happened wasn’t quite as practical. Instead, we arranged a prix fixe tasting menu for the table.',
          'Different format.',
          'Same idea.',
          'Let Bazaar Meat do what Bazaar Meat does.',
          'The tasting menu meant everyone moved through the experience together. The signature bites started arriving, including the cotton candy foie gras, before eventually working our way toward the real star of the meal: the bone-in strip loin, carved tableside and shared around the table.',
          'It was also a good example of something that has become part of these trips.',
          'Some of the best nights during AWS re:Invent aren’t necessarily just the Reckon crew.',
          'We run into people we know. We reconnect with friends from the industry. We meet up at happy hours and conference events. And sometimes we simply invite people along and pull up a few more chairs.',
          'In 2023, Bazaar Meat became one of those nights.',
        ],
      },
      {
        heading: 'Dinner Before the Party',
        paragraphs: [
          'What never changed was what came next.',
          'Bazaar Meat wasn’t the final destination for the night.',
          'AWS re:Play was waiting across the street.',
          'That’s really why Bazaar Meat found such a natural place in our AWS re:Invent routine. It gave us one last chance to slow things down, sit around a table, eat something memorable, and spend time together before heading into one of the biggest parties of the week.',
          'There was also something fitting about the contrast.',
          'We’d spend a couple of hours around a table working our way through an elaborate meal, finishing with a bone-in strip loin carved tableside.',
          'Then we’d get up and head across the street to AWS re:Play.',
          'STK became how we started AWS re:Invent.',
          'For a couple of years, Bazaar Meat became how we started the last night.',
          'Dinner first.',
          'AWS re:Play next.',
          'And after a week in Vegas, that’s a pretty good combination.',
        ],
      },
    ],
    image: bazaarSteakImage,
    imageAlt: 'A sliced steak presented on a stone platter at Bazaar Meat in Las Vegas',
    imagePosition: 'center center',
    websiteUrl: 'https://www.thebazaar.com/location/las-vegas/',
  },
  Catch: {
    titleOverride: 'Catch Las Vegas',
    description: 'Catch paired the energy we want from a Las Vegas dinner with chef-led, family-style seafood experiences that gave us a reason to return in 2024.',
    dayLabel: 'AWS re:Invent 2023–2024',
    location: 'ARIA Resort & Casino, Las Vegas, Nevada',
    whyWeWent: 'Our annual search for a restaurant we had not tried brought us to Catch in 2023, where the atmosphere and food quickly earned it a return visit.',
    whatHappened: 'Both years, we handed the table over to the server and chef for completely different family-style meals centered on seafood with an Asian influence.',
    whatWeRemember: 'The shared dishes, a memorable sake in 2024, and Brandon A.’s still-unconfirmed claim that he saw Mike Tyson leaving Catch in 2023.',
    storySections: [
      {
        heading: 'The Reckon Connection',
        paragraphs: [
          'A month or two before every AWS re:Invent trip, I usually start looking.',
          'Las Vegas changes constantly, and part of the fun is seeing what restaurants are new, what places are generating buzz, and what we haven’t tried yet.',
          'Catch wasn’t actually new when it landed on my list in 2023. It had opened at ARIA in 2018, but with the COVID years in between, I’d never made it there.',
          'It was time to fix that.',
          'So we added Catch to our 2023 AWS re:Invent lineup.',
          'The first thing that got us was the vibe. Catch has the kind of energy that works for one of our Vegas dinners, but unlike some places where the atmosphere is better than what’s on the plate, the food delivered too.',
          'And we don’t always make it particularly easy on the kitchen.',
          'One thing we’ve gotten into the habit of doing at dinners like this is putting ourselves in the hands of the restaurant. Rather than everyone simply ordering an entrée, we’ll ask our server if they’ll work with the chef to put together a family-style meal for the table.',
          'Tell us what we shouldn’t leave without trying.',
          'Send out what the chef thinks we should eat.',
          'Then we see what happens.',
          'At Catch, it worked.',
          'Both years, the meals centered around seafood with an Asian influence, but they were completely different experiences.',
          'In 2023, sushi rolls and other dishes began making their way around the table, including a whole steamed fish meant to be shared. Course after course arrived without everyone having to stare at a menu and decide what to order.',
          'Everyone just tried what showed up.',
          'It turns dinner into more of an experience. You’re sharing the same food, talking about what’s arriving, and inevitably trying something you probably wouldn’t have ordered on your own.',
          'The combination of the food and the atmosphere was enough to put Catch back on the list for 2024.',
          'That’s actually saying something.',
          'With so many new restaurants opening in Las Vegas, I’m usually looking for the next place we haven’t tried. Returning somewhere means it gave us a reason to stop looking for something new.',
          'So the following year, we went back and did it again.',
          'Same restaurant. Same idea. Hand the table over to the server and chef and let them decide where dinner goes.',
          'Completely different meal.',
          'The food in 2024 was every bit as good, if not better, than what we’d had the year before.',
          'But oddly enough, one of the things I remember most from that dinner wasn’t the food.',
          'It was the sake.',
          'Sometimes that’s how these dinners work. You remember a particular dish. Sometimes it’s a drink. Sometimes it’s something that happened at the table.',
          'And sometimes it’s something we’re still not entirely convinced happened at all.',
        ],
      },
      {
        heading: 'The Thing We Still Talk About',
        paragraphs: [
          'Toward the end of our 2023 dinner, Brandon A. got up to use the restroom.',
          'On his way back to the table, he apparently “saw” Mike Tyson.',
          'According to Brandon, Iron Mike and his entourage had been dining at Catch too, and he spotted them just as they were getting up from their table and heading toward the exit.',
          'By the time Brandon made it back to our table and told us, it was too late.',
          'We all looked toward the exit.',
          'All we could see was a group of people walking out of the restaurant.',
          'That was it.',
          'No introduction. No photo. And nobody else at the table got a good enough look to confirm anything.',
          'It could have been Mike Tyson.',
          'It also could have been anyone.',
          'Brandon A. remains convinced.',
          'Naturally, the rest of us have been giving him a hard time about it ever since.',
          'So depending on whose version of Reckon history you choose to believe, AWS re:Invent 2023 was also the night Brandon A. “saw” Mike Tyson at Catch.',
          'We’ll never know.',
          'Which is probably why we’re still talking about it.',
        ],
      },
      {
        heading: 'Why We Came Back',
        paragraphs: [
          'Catch became one of those rare Vegas restaurants that survived the annual search for somewhere new.',
          'The vibe brought plenty of energy to the table. The food backed it up. And by asking the restaurant to create the meal for us, returning didn’t mean repeating the same experience.',
          'In 2023, there was sushi, a whole steamed fish, a table full of seafood and, allegedly, Mike Tyson.',
          'In 2024, there was another completely different dinner, food that may have been even better, and sake good enough that it’s still one of the things I remember.',
          'Two visits.',
          'Two completely different meals.',
          'That’s probably the best reason we could have had to go back.',
        ],
      },
    ],
    image: catchTeamDinnerImage,
    imageAlt: 'The Reckon crew gathered around the table for dinner at Catch in Las Vegas',
    imagePosition: 'center center',
    websiteUrl: 'https://www.catchrestaurants.com/location/catch-las-vegas/',
  },
  Brezza: {
    description: 'A late reservation after Whiskeys of the World gave us an almost-private Brezza experience built around excellent Italian food and memorable wine pairings.',
    dayLabel: 'AWS re:Invent 2024',
    location: 'Resorts World Las Vegas, Las Vegas, Nevada',
    whyWeWent: 'Brezza was one of the most talked-about new restaurants in Las Vegas, making it exactly the kind of place Kevin wanted to add to the 2024 lineup.',
    whatHappened: 'After a relaxed whisky tasting ran long, the crew crossed the Strip, navigated Resorts World, and handed Brezza’s nearly empty dining room over to the chef and sommelier.',
    whatWeRemember: 'The seemingly endless walk to find the restaurant, the quiet late-night atmosphere, excellent Italian courses, and wine pairings that made every dish better.',
    storySections: [
      {
        heading: 'The Restaurant Everyone Was Talking About',
        paragraphs: [
          'Every year before AWS re:Invent, I spend some time looking at what’s happening in the Las Vegas restaurant scene.',
          'What’s new?',
          'What’s getting attention?',
          'And what’s worth adding to the list?',
          'In 2024, one of those restaurants was Brezza.',
          'It was at Resorts World, one of the newer resorts on the Strip, and Brezza seemed to be generating plenty of buzz. I’d never been, which made it exactly the kind of place I wanted to work into the week.',
          'There was only one problem.',
          'We already had plans before dinner.',
        ],
      },
      {
        heading: 'Whisky First',
        paragraphs: [
          'Earlier that evening, we’d hosted Whiskeys of the World in my suite at the Cosmopolitan.',
          'JD from The Whisky Attic had spent the evening teaching us the C-STEM tasting method and taking us through whiskies from around the world. Then I’d surprised everyone with a bottle of Macallan 18 Double Cask for one final pour.',
          'It had been a relaxed night.',
          'Maybe a little too relaxed.',
          'Because eventually we looked at the time and remembered we still had dinner reservations.',
          'At Brezza.',
          'So we wrapped up the tasting, thanked JD, gathered the crew, and headed for Resorts World.',
        ],
      },
      {
        heading: 'Where Is This Restaurant?',
        paragraphs: [
          'Getting there turned out to be part of the experience.',
          'Resorts World is enormous, and Brezza wasn’t exactly sitting there waiting for us when we walked through the doors.',
          'We seemed to walk forever through the mall-like interior of the resort, making our way past shops and through corridors looking for the restaurant.',
          'After an evening of whisky, it felt like a particularly long walk.',
          'Eventually, we found it.',
          'By then, it was late.',
          'And the restaurant we’d heard so much buzz about was nearly empty.',
        ],
      },
      {
        heading: 'Almost to Ourselves',
        paragraphs: [
          'It was a strange contrast.',
          'I’d picked Brezza partly because it was one of the restaurants people were talking about that year. I expected energy and a packed dining room.',
          'Instead, because of our later reservation, it felt like we practically had the place to ourselves.',
          'And I liked it.',
          'After the whisky tasting, gathering everyone up, getting across the Strip, and wandering through Resorts World trying to find the restaurant, suddenly everything slowed down again.',
          'We settled around the table and did what we’d started doing at some of our favorite dinners.',
          'We gave up control of the menu.',
          'Rather than everyone ordering individually, we asked our server to work with the chef and put together the meal for us.',
          'Show us what Brezza does well.',
          'Then pair the wines with it.',
          'And let it come.',
        ],
      },
      {
        heading: 'Italian Food and Really Good Wine',
        paragraphs: [
          'What followed was a progression of Italian dishes coming out of the kitchen, each accompanied by a wine selected to go with it.',
          'I don’t remember every individual plate.',
          'I do remember the experience.',
          'The food was excellent.',
          'And the wine pairings were even more memorable.',
          'With each dish, another wine arrived that seemed to make whatever we were eating better. Instead of ordering a bottle or two for the table and drinking them throughout dinner, the wine became part of the progression of the meal.',
          'Dish.',
          'Wine.',
          'Next dish.',
          'Next wine.',
          'It was exactly why we’ve come to enjoy handing the menu over to the people who know the restaurant better than we ever could.',
          'We weren’t trying to figure out what Brezza did best.',
          'They were showing us.',
          'And with the restaurant nearly empty around us, it almost felt like they were doing it just for our table.',
        ],
      },
      {
        heading: 'A Very Different Kind of Night',
        paragraphs: [
          'Brezza wasn’t loud like STK.',
          'It didn’t have the spectacle of Bazaar Meat.',
          'There was no questionable Mike Tyson sighting like Catch.',
          'And nothing arrived in the quantities we’d eventually experience at Golden Steer.',
          'What I remember is something quieter.',
          'A restaurant we’d heard was generating buzz.',
          'A late reservation after an already great whisky tasting.',
          'A seemingly endless walk through Resorts World to find it.',
          'Then an almost empty dining room, really good Italian food, and wine pairings that kept delivering with every course.',
          'Sometimes the restaurant everyone is talking about isn’t memorable for the reason you expected.',
          'We went to Brezza because it was one of the places generating buzz in Las Vegas.',
          'We remember it because, for one late night during AWS re:Invent, it felt like we had discovered it after everyone else had gone home.',
        ],
      },
    ],
    image: brezzaDinnerImage,
    imageAlt: 'The Reckon crew sharing a coastal Italian spread at Brezza in Las Vegas',
    imagePosition: 'center center',
    websiteUrl: 'https://www.rwlasvegas.com/dining/brezza/',
  },
  'Golden Steer': {
    description: 'Golden Steer delivered an over-the-top old-Vegas feast of seafood towers, tableside classics, tomahawks, lobster, king crab, and enough food to cancel every plan afterward.',
    dayLabel: 'AWS re:Invent 2024',
    location: 'West Sahara Avenue, Las Vegas, Nevada',
    whyWeWent: 'Months of Instagram reels turned the historic Rat Pack-era steakhouse into a bucket-list meal built around steak, lobster, Alaskan king crab legs, and drawn butter.',
    whatHappened: 'A 4:30 p.m. private-room reservation unfolded through seafood towers, tableside Caesar, wine pairings, tomahawks, lobster, king crab, every side imaginable, and flaming Bananas Foster.',
    whatWeRemember: 'The line around the building before opening, our exceptional server, the Caesar salad becoming an unexpected highlight, and a dinner so complete that nobody tried to go back out afterward.',
    storySections: [
      {
        heading: 'The Reckon Connection',
        paragraphs: [
          'By 2024, apparently Instagram had decided I needed to eat at the Golden Steer.',
          'I had never been there.',
          'But for months, my algorithm seemed determined to change that.',
          'Reel after reel showed up in my feed with people sitting in an old-school Las Vegas steakhouse surrounded by almost ridiculous amounts of food.',
          'Huge steaks.',
          'Lobster tails.',
          'Alaskan king crab legs.',
          'And, most importantly, fresh drawn butter being poured over all of it.',
          'Eventually, you can only watch that happen so many times before you need to experience it yourself.',
          'The Golden Steer became a bucket-list Vegas meal.',
          'So when I started putting together our restaurant lineup for AWS re:Invent 2024, it was going on the list.',
        ],
      },
      {
        heading: 'Old Vegas',
        paragraphs: [
          'What made Golden Steer even more interesting was that this wasn’t another new Las Vegas restaurant generating buzz.',
          'It was the opposite.',
          'Golden Steer had been around since 1958, with decades of old Vegas history attached to it. Frank Sinatra, Dean Martin, Sammy Davis Jr., Elvis Presley, and plenty of other names had eaten there over the years.',
          'After spending so much of AWS re:Invent surrounded by enormous screens, new technology, new hotels, and a Las Vegas that seems to reinvent itself every few years, there was something appealing about going somewhere that had been serving steaks since the Rat Pack era.',
          'But if I’m being completely truthful, the history wasn’t what originally got it onto my list.',
          'Instagram did.',
          'I wanted the steak.',
          'I wanted the lobster.',
          'I wanted the Alaskan king crab legs.',
          'And I definitely wanted the drawn butter.',
        ],
      },
      {
        heading: 'The Line Around the Block',
        paragraphs: [
          'Getting our group into Golden Steer required a little more planning than making a normal dinner reservation.',
          'With a crew our size, we had to book private dining.',
          'That meant our reservation was right when the restaurant opened.',
          'At 4:30 in the afternoon.',
          'On a Wednesday.',
          'That’s not exactly what you picture when you think about going out for a steak dinner in Las Vegas.',
          'Then we arrived.',
          'Golden Steer sits in a pretty unassuming strip mall, away from all the spectacle of the Strip. But when we got there, there was already a line of people stretching around the building waiting for the doors to open.',
          'At 4:30.',
          'On a Wednesday.',
          'Suddenly the early dinner reservation didn’t seem quite so strange.',
          'When the doors opened, instead of joining the line, our group was brought inside and led past everyone waiting and toward the back of the restaurant.',
          'There, tucked away from the main dining room, was a small private room set up for us.',
          'It was a funny way to start the night.',
          'Outside, a line around the building in a random Las Vegas strip mall.',
          'Inside, our own private room.',
          'And somewhere between the two was all that steak, lobster, crab, and drawn butter Instagram had been feeding me for months.',
          'We were finally going to find out whether it lived up to the algorithm.',
        ],
      },
      {
        heading: 'And That Was Just the Beginning',
        paragraphs: [
          'When we walked into the private room, the seafood towers were already there waiting for us.',
          'That immediately set the tone.',
          'We hadn’t even really settled into our seats yet, and the table was already covered in seafood.',
          'For a group our size, we had arranged a fixed family-style menu ahead of time, so there wasn’t much deciding left to do.',
          'We could sit down and let Golden Steer take it from there.',
          'Our server was amazing from the beginning.',
          'He took what could have simply been a very large steakhouse dinner and turned it into an experience. He even came up with wine pairings to carry us through the different courses.',
          'Then came one of the biggest surprises of the night.',
          'The Caesar salad.',
          'It was prepared completely tableside, dressing and all, in that classic old-school steakhouse style.',
          'And it was amazing.',
          'I’d gone into Golden Steer thinking about giant steaks, lobster tails, Alaskan king crab legs, and drawn butter.',
          'I wasn’t expecting the Caesar salad to be one of the things I’d still remember.',
          'Then came the Butcher’s Cut meatballs and baked crab cakes.',
          'Both were good.',
          'Really good, actually.',
          'But in retrospect, the seafood towers, tableside Caesar, meatballs, and crab cakes were all just the opening act.',
          'Because the onslaught of food hadn’t even started yet.',
        ],
      },
      {
        heading: 'The Main Event',
        paragraphs: [
          'Then the table really started to disappear.',
          'Tomahawk steaks.',
          'Australian lobster tails.',
          'Alaskan king crab legs.',
          'And all the sides.',
          'Whipped potatoes.',
          'Creamed spinach.',
          'Macaroni and cheese.',
          'Sherry cream mushrooms.',
          'This was it.',
          'This was essentially the meal my Instagram algorithm had been putting in front of me for months.',
          'Huge steaks surrounded by an almost unreasonable amount of seafood. Lobster tails and massive Alaskan king crab legs covering the table.',
          'And, of course, the drawn butter.',
          'Watching reel after reel on a phone doesn’t really prepare you for what happens when all of it starts arriving at the same table.',
          'Somewhere in the middle of it all, our server was still guiding us through the wine pairings.',
          'This wasn’t just a big steak dinner anymore.',
          'It was the ridiculous, over-the-top Golden Steer experience I’d put on my Vegas bucket list.',
          'And somehow, Golden Steer still wasn’t finished with us.',
        ],
      },
      {
        heading: 'Somehow, There Was Dessert',
        paragraphs: [
          'By this point, nobody needed more food.',
          'There shouldn’t have been any room left.',
          'But for the final course, Golden Steer rolled out one more bit of classic old-school steakhouse theater.',
          'Bananas Foster.',
          'And just like the Caesar earlier in the meal, the entire thing was prepared tableside.',
          'We watched as the bananas were sliced and added to a pan with butter, brown sugar, cinnamon, and banana liqueur.',
          'Everything began bubbling together right next to us, the bananas softening as the butter and brown sugar turned into a warm caramelized sauce.',
          'Then came the rum.',
          'A pour into the pan.',
          'A flame.',
          'And suddenly dessert was flambéing beside the table.',
          'The flames eventually disappeared, leaving behind warm caramelized bananas covered in that sauce of butter, brown sugar, cinnamon, banana liqueur, and rum.',
          'It was amazing.',
          'I have absolutely no idea how any of us found room to eat it.',
          'But somehow we did.',
          'It was a fitting ending to a meal that had been completely over the top from the moment we walked into the private room.',
          'Seafood towers waiting for us.',
          'Tableside Caesar.',
          'Meatballs and crab cakes.',
          'Tomahawks.',
          'Australian lobster tails.',
          'Alaskan king crab legs.',
          'Wine pairings.',
          'More sides than anyone needed.',
          'And finally, tableside Bananas Foster when none of us had any business eating another bite.',
        ],
      },
      {
        heading: 'So Much for Going Out',
        paragraphs: [
          'The funny thing is, dinner wasn’t supposed to be the end of our night.',
          'We had plans to go out afterward.',
          'At least, that had been the plan before we sat down at Golden Steer.',
          'Eventually we made our way back to the hotel, and something unusual happened.',
          'Nothing.',
          'Normally, once everyone gets back to their rooms, the group texts start.',
          '“Where is everyone?”',
          '“Who’s coming down?”',
          '“Where are we meeting?”',
          'Someone starts trying to rally the crew for whatever comes next.',
          'That night, strangely, there were no texts.',
          'No one asking where we were going.',
          'No one trying to get everyone back downstairs.',
          'No attempt whatsoever to resurrect the plans we’d made earlier.',
          'Just silence.',
          'Apparently seafood towers, tableside Caesar, meatballs, crab cakes, tomahawk steaks, Australian lobster tails, Alaskan king crab legs, four sides, wine pairings, and a flaming pan of Bananas Foster had accomplished something very few things in Las Vegas could.',
          'They convinced all of us to stay in.',
          'I’d spent months watching Instagram reels of people eating ridiculous amounts of steak and seafood at Golden Steer until the algorithm finally convinced me that I needed to experience it myself.',
          'For once, the algorithm got it exactly right.',
          'Although apparently it forgot to warn me not to make plans afterward.',
        ],
      },
    ],
    image: goldenSteerGroupImage,
    imageAlt: 'The Reckon crew gathered beneath the Golden Steer marquee in Las Vegas',
    imagePosition: 'center center',
    websiteUrl: 'https://goldensteer.com/pages/las-vegas',
  },
  'Don’s Prime': {
    description: 'A good dinner at a new Las Vegas resort gave us the perfect starting point for the walk to AWS re:Play, even if Don’s Prime never became a tradition.',
    dayLabel: 'AWS re:Invent 2024',
    location: 'Fontainebleau Las Vegas, Las Vegas, Nevada',
    whyWeWent: 'Fontainebleau was new, Don’s Prime offered a steakhouse we had not tried, and the resort’s location made it a practical stop before AWS re:Play.',
    whatHappened: 'The crew explored Fontainebleau, enjoyed a polished steakhouse dinner, and then walked to the Las Vegas Festival Grounds for the end-of-conference party.',
    whatWeRemember: 'A genuinely good meal that did exactly what we needed, without a signature dish, inside joke, or moment that demanded it become a recurring stop.',
    storySections: [
      {
        heading: 'Something New',
        paragraphs: [
          'Sometimes the restaurant determines where we go.',
          'Other times, where we want to go determines the restaurant.',
          'Don’s Prime was a little bit of both.',
          'Fontainebleau Las Vegas opened in December 2023, just after we’d left town following AWS re:Invent that year. So when we returned for AWS re:Invent 2024, there was an entirely new resort on the Strip that we hadn’t explored.',
          'We wanted to check it out.',
          'Don’s Prime gave us a reason to.',
          'There was also some strategy to the choice.',
          'In previous years, we’d eaten at Bazaar Meat before heading to AWS re:Play. Its location near the Las Vegas Festival Grounds made it a natural dinner stop before the end-of-conference party.',
          'Fontainebleau was also nearby.',
          'So instead of returning to Bazaar Meat again, we could try a new steakhouse, explore the new resort, and then walk over to AWS re:Play when dinner was finished.',
          'Perfect.',
          'At least on paper.',
        ],
      },
      {
        heading: 'A Good Steakhouse',
        paragraphs: [
          'Dinner was good.',
          'Everyone ordered what they wanted from the menu. The steaks were good. The restaurant was nice. The service was what you’d expect from a high-end Las Vegas steakhouse.',
          'There was nothing wrong with Don’s Prime.',
          'There also isn’t a particular dish I can tell you about years later.',
          'No presentation that became part of the story.',
          'No inside joke.',
          'No moment everyone still talks about.',
          'It was simply a really nice steakhouse and a good dinner.',
          'And sometimes that’s all dinner needs to be.',
        ],
      },
      {
        heading: 'Maybe We Were Eating Too Well',
        paragraphs: [
          'By this point in our AWS re:Invent trips, we’d gotten pretty good at eating our way around Las Vegas.',
          'Maybe too good.',
          'We had a habit of packing the week with restaurants. Steakhouses, tasting menus, family-style dinners, wine pairings, and whatever new place had caught my attention while planning the trip.',
          'Eventually, even really good meals start competing with other really good meals.',
          'I remember sitting at Don’s Prime thinking essentially that.',
          'This is good.',
          'This is a really nice steakhouse.',
          'But there wasn’t anything about it that made me think, We have to do this again.',
          'That’s not really a criticism of Don’s Prime.',
          'It may say more about us.',
          'When you’ve spent the week eating some pretty ridiculous meals, another great steak can just become another great steak.',
        ],
      },
      {
        heading: 'Dinner, Then AWS re:Play',
        paragraphs: [
          'What Don’s Prime did give us was exactly what we’d originally wanted.',
          'A reason to explore Fontainebleau.',
          'A good dinner together.',
          'And a convenient starting point for the rest of the night.',
          'When we finished, we left Fontainebleau and walked over to the Las Vegas Festival Grounds for AWS re:Play.',
          'In previous years, Bazaar Meat had filled that role.',
          'In 2024, we tried something new.',
          'Don’s Prime was good.',
          'Fontainebleau was new.',
          'AWS re:Play was waiting.',
          'Not every restaurant has to become a tradition.',
          'Sometimes it’s simply where you ate before the next part of the story began.',
        ],
      },
    ],
    image: donsPrimeDinnerImage,
    imageAlt: 'The Reckon crew sharing an elaborate seafood spread at Don’s Prime in Las Vegas',
    imagePosition: 'center center',
    websiteUrl: 'https://www.fontainebleaulasvegas.com/dining/restaurants/dons-prime/',
  },
  'Estiatorio Milos': {
    description: 'A long-awaited return to an old favorite paired fresh Mediterranean seafood, an unexpected Greek wine, and a salt-crusted whole fish with the Eagles at Sphere afterward.',
    dayLabel: 'AWS re:Invent 2024',
    location: 'The Venetian Resort, Las Vegas, Nevada',
    whyWeWent: 'Milos had been one of Kevin’s favorite restaurants at the Cosmopolitan, but private events made its Venetian location nearly impossible to book during AWS re:Invent until the crew stayed an extra day in 2024.',
    whatHappened: 'The server and fishmonger guided the crew through the day’s market selection, the kitchen chose the meal, and dinner unfolded through seafood, Greek wine, and a whole fish cracked from its salt crust tableside.',
    whatWeRemember: 'The orange-colored Greek wine, the simplicity of fish with olive oil, lemon, and capers, and finally returning to an old favorite before walking to see the Eagles at Sphere.',
    storySections: [
      {
        heading: 'An Old Favorite in a New Home',
        paragraphs: [
          'Milos wasn’t a restaurant I needed to discover.',
          'It had been one of my favorites for years.',
          'Back when Estiatorio Milos was at the Cosmopolitan, it was probably my favorite restaurant in the hotel. And considering how many great restaurants the Cosmo has had, that’s saying something.',
          'Eventually, Milos moved from the Cosmopolitan to the Venetian.',
          'The new location created an unexpected problem for us.',
          'During AWS re:Invent, Milos was usually closed for private events.',
          'Year after year, we’d be in Las Vegas and one of my favorite restaurants would be sitting right there, but getting a reservation during the conference was almost impossible.',
          'In 2024, our schedule finally worked in our favor.',
          'AWS re:Invent was over.',
          'But we weren’t going home yet.',
          'We had stayed an extra day to see the Eagles at the Sphere. With Milos at the Venetian and the Sphere right there, suddenly everything lined up.',
          'One of my favorite restaurants.',
          'A reservation we could finally get.',
          'And the Eagles waiting for us afterward.',
        ],
      },
      {
        heading: 'Let’s See What’s Fresh',
        paragraphs: [
          'Getting seated at Milos isn’t necessarily the beginning of dinner.',
          'At least it wasn’t for us.',
          'Once we were settled in, we were led over to the restaurant’s fish market.',
          'That’s part of what makes Milos different.',
          'Instead of simply reading descriptions from a menu, you’re standing in front of the day’s selection of whole fish and seafood, actually looking at what’s fresh.',
          'Our server joined us along with the fishmonger, and we started talking through what had come in, what they recommended, and how different things could be prepared.',
          'But eventually we arrived at a familiar decision.',
          'Why were we trying to figure this out?',
          'We were standing in a fish market with a fishmonger, a server, and an entire kitchen full of people who knew far more about what was best that day than we did.',
          'So we handed dinner over to them.',
          'Work with the chef.',
          'Pick what we should eat.',
          'Show us what Milos does best.',
          'And start sending it out.',
        ],
      },
      {
        heading: 'Something Different in the Glass',
        paragraphs: [
          'The kitchen wasn’t the only thing we turned over to Milos.',
          'As the dishes started coming, so did the wine.',
          'One in particular stuck with me.',
          'It was a Greek wine with a distinctive orange color, unlike the whites we might normally have expected with a seafood dinner.',
          'I don’t remember the producer or the grape.',
          'I remember the color.',
          'And I remember it being really good.',
          'That’s one of the things I enjoy about giving a restaurant some freedom with the meal. Left to our own devices, we probably would have looked at the wine list and ordered something familiar.',
          'Instead, they put something in front of us that most of us probably wouldn’t have selected ourselves.',
          'And that was exactly the point.',
        ],
      },
      {
        heading: 'Encased in Salt',
        paragraphs: [
          'Eventually, one of the signature dishes Milos is known for arrived at the table.',
          'A whole fresh fish completely encased in a thick crust of sea salt.',
          'By the time it reaches the table, you can’t really see the fish anymore.',
          'Just this big shell of hardened salt.',
          'Then the show starts.',
          'The server cracks open the crust tableside and begins pulling away the salt, revealing the whole fish underneath.',
          'From there, the fish is carefully deboned right in front of us and portioned into tender fillets for everyone around the table.',
          'After all that presentation, what ends up on the plate is remarkably simple.',
          'Fresh fish.',
          'Olive oil.',
          'Lemon.',
          'Capers.',
          'That’s really Milos in a dish.',
          'There isn’t a heavy sauce trying to turn the fish into something else. The whole point is the quality and freshness of what we had just stood at the fish market discussing with the fishmonger.',
          'Now that fish was sitting in front of us.',
          'And it was exactly why I’d missed eating there.',
        ],
      },
      {
        heading: 'Before the Eagles',
        paragraphs: [
          'There was something particularly nice about finally getting back to Milos this way.',
          'For years, its old location at the Cosmo had made it one of my favorite restaurants in Las Vegas. Then it moved to the Venetian and, strangely, became harder for us to visit because it was so often booked for private events during AWS re:Invent.',
          'This time, AWS re:Invent was already over.',
          'There were no conference events left to get to.',
          'We’d stayed in Las Vegas for one more night because we had somewhere else to be.',
          'The Eagles at the Sphere.',
          'So we finally got our reservation at Milos.',
          'We stood at the fish market with the server and fishmonger and let them help decide what we should eat.',
          'We drank an orange-colored Greek wine I probably never would have picked for myself.',
          'We watched a whole fish emerge from a shell of salt and get deboned tableside.',
          'And we returned to an old favorite in its new home.',
          'Then we left dinner and headed for the Sphere.',
          'Not a bad opening act.',
        ],
      },
    ],
    image: estiatorioMilosSeafoodImage,
    imageAlt: 'A market display of whole Mediterranean fish on ice at Estiatorio Milos in Las Vegas',
    imagePosition: 'center center',
    websiteUrl: 'https://www.estiatoriomilos.com/location/lasvegas/',
  },
  'Jean-Georges Steakhouse': {
    description: 'A convenient client dinner at ARIA became an opportunity to share the communal dining tradition Reckon first discovered at Amalfi years earlier.',
    dayLabel: 'AWS re:Invent 2025',
    location: 'ARIA Resort & Casino, Las Vegas, Nevada',
    whyWeWent: 'Jean-Georges made dinner easy for clients staying at ARIA while giving Kevin and Marcus a chance to share the way Reckon had learned to experience Las Vegas restaurants together.',
    whatHappened: 'After everyone finally found the restaurant, the table handed the menu to the staff and shared each chef-selected dish as it arrived.',
    whatWeRemember: 'Not one particular steak or side, but how quickly “Just feed us” turned a client dinner into a shared conversation and an expression of The Reckon Way.',
    storySections: [
      {
        heading: 'The Way We Roll',
        paragraphs: [
          'Once everyone finally found the restaurant and made it to the table, we could have ordered like a normal client dinner.',
          'Everyone picks a steak.',
          'Choose a couple of sides.',
          'Order some wine.',
          'Done.',
          'But by 2025, Marcus and I had spent enough nights eating our way through Las Vegas to know there was another option.',
          'So we introduced our clients to the way we roll.',
          'We asked the staff to take over.',
          'Work with the kitchen.',
          'Choose the dishes you think we should experience.',
          'Put together the meal for the table.',
          'And keep it coming.',
          'It’s something we’d first stumbled into years earlier at Amalfi and had repeated at restaurants all over Las Vegas since.',
          'There’s a reason we keep doing it.',
          'It immediately changes the dynamic of dinner.',
          'Instead of everyone disappearing into a menu and making their own decisions, the entire table is sharing the same experience.',
          'Something arrives.',
          'Everyone tries it.',
          'Another dish appears.',
          'Pass it around.',
          'What is this?',
          'Did you try that?',
          'Would you ever have ordered this yourself?',
          'Dinner becomes a conversation.',
          'And for a client dinner, that’s exactly what you want.',
        ],
      },
      {
        heading: 'More Than a Steak Dinner',
        paragraphs: [
          'That’s probably what I remember most about Jean-Georges.',
          'Not a particular steak.',
          'Not a specific side.',
          'Not some elaborate tableside presentation.',
          'We had chosen Jean-Georges because our clients were staying at ARIA and we wanted to make things easy for them.',
          'They still managed to get lost.',
          'Then, once everyone finally made it to the table, we introduced them to a tradition we’d developed over several years of AWS re:Invent dinners.',
          'Don’t overthink the menu.',
          'Trust the people who know the restaurant.',
          'Share everything.',
          'And see where dinner takes you.',
          'Sometimes The Reckon Way shows up in much bigger things.',
          'And sometimes it’s as simple as saying:',
          'Just feed us.',
        ],
      },
    ],
    websiteUrl: 'https://www.jean-georges.com/restaurants/united-states/las-vegas/jean-georges-steakhouse/',
  },
};
const restaurantVisits = getRecurringRestaurantVisits(years).map((restaurant) => ({
  ...restaurant,
  ...(restaurantMetadata[restaurant.name] || {}),
}));
const badgesByYear = {
  'atvs-mojave-desert': 2022,
  'utvs-mojave-desert': 2023,
  'u2-at-sphere': 2023,
  'valley-of-fire-off-roading': 2024,
  'hiking-zion-national-park': 2024,
  'eagles-at-sphere': 2024,
};

const awsReinvent = defineReckonEvent({
  id: 'aws-reinvent-las-vegas',
  slug: 'aws-reinvent-las-vegas',
  title: 'AWS re:Invent',
  subtitle: 'An annual Reckon tradition built around cloud technology, unforgettable dinners, and adventures beyond the conference floor.',
  eventType: 'conference',
  category: 'Recurring Conference',
  classification: 'Recurring Conference',
  recurring: true,
  status: 'published',
  destination: 'Las Vegas, Nevada',
  city: 'Las Vegas',
  region: 'Nevada',
  country: 'United States',
  yearsLabel: '2022 to 2025',
  heroImage: {
    id: 'aws-reinvent-hero',
    src: awsReinventHero,
    alt: 'AWS re:Invent in Las Vegas, part of The Reckon Way',
    position: 'center center',
  },
  summary: 'AWS re:Invent has become one of Reckon’s recurring conference traditions. Each trip combines the scale and energy of the conference with team dinners, outdoor adventures, live entertainment, and time together away from the office. Rather than treating each year as a separate trip, this page follows the experience as it evolves. New team members join, favorite restaurants return, and every year adds another chapter to the story.',
  summaryParagraphs: [
    'AWS re:Invent has become one of Reckon’s recurring conference traditions. Each trip combines the scale and energy of the conference with team dinners, outdoor adventures, live entertainment, and time together away from the office.',
    'Rather than treating each year as a separate trip, this page follows the experience as it evolves. New team members join, favorite restaurants return, and every year adds another chapter to the story.',
  ],
  years,
  activities,
  restaurantVisits,
  recurringCrew: getRecurringAttendees(years, crewDirectory),
  atAGlance: getRecurringEventStats(years, activities),
  typicalHotel: {
    name: 'The Cosmopolitan of Las Vegas',
    label: 'Typical AWS re:Invent stay',
    description: "The Cosmopolitan is the Reckon Crew's usual home base during AWS re:Invent, putting us in the middle of the Las Vegas Strip for conference days, team dinners, and everything that happens after the sessions end.",
    highlights: [
      'Our usual AWS re:Invent hotel',
      'Central Las Vegas Strip location',
      'A familiar base for the week',
    ],
  },
  traditions: [
    { title: 'STK', description: 'A recurring stop during Reckon’s first three years at AWS re:Invent.', years: [2022, 2023, 2024] },
    { title: 'Bazaar Meat', description: 'A return favorite during the 2022 and 2023 trips.', years: [2022, 2023] },
    { title: 'Catch', description: 'Part of the AWS re:Invent dining lineup in 2023 and 2024.', years: [2023, 2024] },
    { title: 'Sphere', description: 'The crew experienced two major concerts at Sphere across consecutive years.', years: [2023, 2024] },
    { title: 'Mojave Off-Roading', description: 'ATVs in 2022 were followed by UTVs in 2023.', years: [2022, 2023] },
  ],
  meritBadges: achievementRefs(
    'atvs-mojave-desert',
    'utvs-mojave-desert',
    'u2-at-sphere',
    'valley-of-fire-off-roading',
    'hiking-zion-national-park',
    'eagles-at-sphere',
  ).map((badge) => ({ ...badge, year: badgesByYear[badge.slug] })),
  gallery: [
    {
      id: 'stk-crew-table-2022-5298',
      src: vegas2022Stk5298Image,
      alt: 'The 2022 Reckon crew gathered around the table at STK Las Vegas',
      caption: 'The first AWS re:Invent crew kicking off the 2022 trip at STK.',
    },
    {
      id: 'stk-steaks-2022-5302',
      src: vegas2022Stk5302Image,
      alt: 'Steaks, sides, and wine spread across the table at STK Las Vegas',
      caption: 'The food that helped make STK our traditional AWS re:Invent kickoff.',
    },
    {
      id: 'atv-break-2022-5314',
      src: vegas2022Atv5314Image,
      alt: 'A Reckon crew member standing beside the ATVs during the 2022 Mojave Desert tour',
      caption: 'A quick break beside the ATVs in the Mojave Desert.',
    },
    {
      id: 'atv-rider-2022-5315',
      src: vegas2022Atv5315Image,
      alt: 'A Reckon crew member seated on an ATV in the Mojave Desert',
      caption: 'Ready to get back onto the Mojave Desert trail.',
    },
    {
      id: 'atv-trail-break-2022-5318',
      src: vegas2022Atv5318Image,
      alt: 'A Reckon crew member taking a break beside the ATVs in the Mojave Desert',
      caption: 'Blue skies and open desert during the 2022 ATV tour.',
    },
    {
      id: 'amalfi-seafood-market-2022-5383',
      src: vegas2022Amalfi5383Image,
      alt: 'The Reckon crew visiting the seafood market at Amalfi by Bobby Flay in 2022',
      caption: 'Choosing from the seafood market at Amalfi by Bobby Flay.',
    },
    {
      id: 'bazaar-meat-locker-2022-5396',
      src: vegas2022Bazaar5396Image,
      alt: 'The dry-aged beef display at Bazaar Meat in Las Vegas',
      caption: 'The dry-aged beef display set the stage at Bazaar Meat in 2022.',
    },
    {
      id: 'bazaar-meat-crew-2022-5398',
      src: vegas2022Bazaar5398Image,
      alt: 'Members of the Reckon crew at dinner inside Bazaar Meat in 2022',
      caption: 'The first Reckon visit to what became a return favorite.',
    },
    {
      id: 'bazaar-meat-steak-2023',
      src: bazaarSteakImage,
      alt: 'A sliced steak presented on a stone platter at Bazaar Meat in Las Vegas',
      caption: 'The centerpiece at Bazaar Meat during AWS re:Invent 2023.',
    },
    {
      id: 'bazaar-meat-opening-bites-2023',
      src: bazaarBitesImage,
      alt: 'Creative opening bites presented on a black stone platter at Bazaar Meat',
      caption: 'Creative presentation from the opening bites at Bazaar Meat.',
    },
    {
      id: 'bazaar-meat-cotton-candy-2023',
      src: bazaarCottonCandyImage,
      alt: 'Cotton candy served on individual sticks at Bazaar Meat',
      caption: 'Cotton candy foie gras made for a theatrical start to dinner at Bazaar Meat.',
    },
    {
      id: 'brezza-team-dinner-2024',
      src: brezzaDinnerImage,
      alt: 'The Reckon crew sharing a coastal Italian spread at Brezza in Las Vegas',
      caption: 'A table full of coastal Italian dishes at Brezza during AWS re:Invent 2024.',
    },
    {
      id: 'dons-prime-seafood-spread-2024',
      src: donsPrimeDinnerImage,
      alt: 'The Reckon crew sharing an elaborate seafood spread at Don’s Prime in Las Vegas',
      caption: 'The seafood spread took over the table at Don’s Prime during AWS re:Invent 2024.',
    },
    {
      id: 'stk-team-dinner-2023',
      src: stkDinnerImage,
      alt: 'The Reckon crew gathered around the dinner table at STK Las Vegas',
      caption: 'The 2023 AWS re:Invent kickoff dinner at STK.',
    },
    {
      id: 'stk-crew-2023',
      src: stkCrewImage,
      alt: 'The Reckon crew together inside STK Las Vegas',
      caption: 'The crew soaking up the energy at STK.',
    },
    {
      id: 'stk-toast-2023',
      src: stkToastImage,
      alt: 'The Reckon crew raising a toast inside STK Las Vegas',
      caption: 'A toast to the start of another AWS re:Invent week.',
    },
    {
      id: 'stk-team-dinner-2024',
      src: stkDinner2024Image,
      alt: 'The Reckon crew gathered around the dinner table at STK Las Vegas in 2024',
      caption: 'Another AWS re:Invent week kicked off together at STK in 2024.',
    },
    {
      id: 'utv-crew-group',
      src: utvCrewGroupImage,
      alt: 'The Reckon crew gathered around blue UTVs in the Mojave Desert',
      caption: 'The 2023 Reckon crew and their UTVs in the Mojave Desert.',
    },
    {
      id: 'utv-driver',
      src: utvDriverImage,
      alt: 'A helmeted Reckon crew member seated behind the wheel of a blue UTV',
      caption: 'Ready to head out onto the desert trail.',
    },
    {
      id: 'utv-trail-break',
      src: utvTrailBreakImage,
      alt: 'The Reckon crew taking a break together on the Mojave Desert trail',
      caption: 'A trail break during the 2023 UTV adventure.',
    },
    {
      id: 'utv-gearing-up',
      src: utvGearUpImage,
      alt: 'The Reckon crew gearing up with helmets before the UTV tour',
      caption: 'Gearing up before heading into the Mojave Desert.',
    },
    {
      id: 'utv-trail-briefing',
      src: utvTrailBriefingImage,
      alt: 'The Reckon crew listening to the UTV trail briefing in the Mojave Desert',
      caption: 'One last trail briefing before the engines started.',
    },
    {
      id: 'utv-driver-view',
      src: utvDriverViewImage,
      alt: 'A driver\'s view from inside a UTV looking across the Mojave Desert',
      caption: 'The Mojave Desert from behind the wheel.',
    },
    {
      id: 'utv-behind-the-wheel',
      src: utvBehindTheWheelImage,
      alt: 'A helmeted Reckon crew member behind the wheel of a UTV',
      caption: 'Helmet on and ready to ride.',
    },
    {
      id: 'u2-sphere-crew-2023',
      src: u2SphereCrewImage,
      alt: 'The Reckon crew beneath the U2 UV Achtung Baby Live at Sphere display',
      caption: 'The crew at Sphere for U2 in 2023.',
    },
    {
      id: 'u2-sphere-concert-2023',
      src: u2SphereConcertImage,
      alt: 'U2 performing beneath an immersive display of birds and butterflies inside Sphere',
      caption: 'U2 surrounded by the immersive scale of Sphere.',
    },
    {
      id: 'catch-team-dinner',
      src: catchTeamDinnerImage,
      alt: 'The Reckon crew gathered around the table for dinner at Catch in Las Vegas',
      caption: 'Dinner together at Catch during AWS re:Invent 2024.',
    },
    {
      id: 'catch-flower-wall-2023',
      src: catchFlowerWallImage,
      alt: 'The Reckon crew seated beneath the flower-covered Catch sign in Las Vegas',
      caption: 'The crew at Catch during the first visit in 2023.',
    },
    {
      id: 'catch-team-dinner-2023',
      src: catchDinner2023Image,
      alt: 'The Reckon crew gathered around the table at Catch in Las Vegas',
      caption: 'Around the table at Catch during AWS re:Invent 2023.',
    },
    {
      id: 'golden-steer-group',
      src: goldenSteerGroupImage,
      alt: 'The Reckon crew gathered beneath the Golden Steer marquee in Las Vegas',
      caption: 'The crew outside Golden Steer after a classic Las Vegas dinner.',
    },
    {
      id: 'estiatorio-milos-seafood-market-2024',
      src: estiatorioMilosSeafoodImage,
      alt: 'A market display of whole Mediterranean fish on ice at Estiatorio Milos in Las Vegas',
      caption: 'Choosing from the seafood market at Estiatorio Milos during AWS re:Invent 2024.',
    },
    ...eaglesStoryGallery,
    {
      id: 'whiskeys-of-the-world-bottles',
      src: whiskeysOfTheWorldImage,
      alt: 'A black-and-white lineup of whisky bottles selected for the tasting',
      caption: 'A tour through whiskies from around the world during AWS re:Invent 2024.',
    },
    {
      id: 'whiskeys-of-the-world-crew',
      src: whiskeyTastingCrewImage,
      alt: 'The Reckon crew raising glasses together during the whisky tasting',
      caption: 'Raising a glass together during the Whisky Attic tasting.',
    },
    whiskySuitePartyPhoto,
    whiskyBalconyGlassPhoto,
    whiskyBottleLineupClip,
    whiskyCstemTastingClip,
    ...valleyOfFireGallery,
    ...zionHikeGallery,
    {
      id: 'zion-hike-video-100612',
      firebaseAssetId: 'zion-hike-video-100612',
      type: 'video',
      mimeType: 'video/mp4',
      captionsSrc: '/captions/aws-reinvent-2024-zion-hike-100612.vtt',
      alt: 'Hiking the Zion National Park trail during AWS re:Invent 2024',
      caption: 'On the trail during the 2024 Zion National Park hike.',
    },
    {
      id: 'zion-hike-video-130042',
      firebaseAssetId: 'zion-hike-video-130042',
      type: 'video',
      mimeType: 'video/mp4',
      captionsSrc: '/captions/aws-reinvent-2024-zion-hike-130042.vtt',
      alt: 'Zion National Park trail views during AWS re:Invent 2024',
      caption: 'Taking in the Zion trail views with the Reckon crew.',
    },
  ],
  tags: tagRefs(
    'conference',
    'annual-event',
    'adventure',
    'team-building',
    'united-states',
    'city-exploration',
    'fine-dining',
    'steakhouse',
    'live-music',
    'hiking',
    'conference-series',
    'best-restaurants',
  ),
  heroTags: ['Conference', 'AWS', 'Las Vegas', 'Technology', 'Team Travel', 'Dining', 'Adventure', 'Recurring Event'],
});

export default awsReinvent;
